Em.I18n.locales ||= {}
module.exports = Em.I18n.locales['tr'] =
  status_mini_popup:
    confirm_sms_hint: 'Sipariş onayı ile ilgili müşteriye SMS bildirimi gönder'
    cancel_sms_hint: 'Sipariş iptali ile ilgili müşteriye SMS bildirimi gönder'
  draft_dish:
    weight_units:
      gram: 'gram'
      kilogram: 'kilogram'
      milliliter: 'mililitre'
      liter: 'litre'
    weight_units_short:
      gram: 'g'
      milliliter: 'ml'
      liter: 'l'
      kilogram: 'kg'
    excise_units:
      commodity: 'Emtia'
      excise: 'Tüketilebilir Emtia'
      service: 'Hizmet'
      excise_with_label: 'Etiketleme kodu olmayan Özel Tüketime Tabi Emtia'
      excise_without_label: 'Etiketleme kodu ile Özel Tüketim Vergisi Uygulanabilir Emtia'
      commodity_with_label: 'Etiketleme koduna sahip İstisna Edilemeyen Emtia'
      commodity_without_label: 'Etiketleme kodu olmayan İstisna Edilemez Emtia'
      other: 'Diğer'
  loyalty:
    notifier:
      title: 'Sadakat Programı {{text}}'
      status:
        new: 'oluşturuldu'
        old: 'kaydedildi'
    confirm:
      delete: 'Sadakat programını silmek istiyor musunuz?'
      cancel: 'Değişiklikleri iptal etmek istiyor musunuz?'
  client_tag_info:
    notifier:
      title: 'Etiket {{text}}'
      status:
        new: 'oluşturuldu'
        old: 'kaydedildi'
    confirm:
      delete: 'Etiket silinsin mi?'
      cancel: 'Değişiklikleri iptal etmek istiyor musunuz?'
  banner:
    notifier:
      title: 'Afiş {{text}}'
      status:
        new: 'oluşturuldu'
        old: 'kaydedildi'
    confirm:
      delete: 'Afişi silelim mi?'
      cancel: 'Değişiklikleri geri al?'
      save: 'Resmi yüklemeden önce afişi kaydetmek istiyor musunuz? Kaydetmek mi?'
  advert:
    confirm:
      delete: 'Reklamı sileyim mi?'
      cancel: 'Değişiklikleri iptal mi edelim?'
      save: 'Bir fotoğraf yüklemeden önce reklamınızı kaydetmeniz gerekir. Kaydetmek mi?'
      execute: 'Haber bülteninin lansmanını onaylayın. {{clients}} misafir etkilenecektir.'
      cancel: 'Planlanan bir bülteni iptal etmek mi?'
    status:
      draft: 'Taslak'
      scheduled: 'Başlatıldı'
      processing: 'Toplu gönderim devam ediyor'
      paused: 'Toplu gönderim durduruldu'
      canceled: 'Toplu gönderim iptal edildi'
      complete: 'Toplu gönderim tamamlandı'
    result:
      error:'Hata'
      success: 'Başarıyla'
    transport:
      sms: 'SMS'
      email: 'E-mail'
      client_push_then_sms: 'Push, sonra SMS'
      client_push: 'Push'
  sip:
    status:
      online: 'Çevrimiçi'
      offline: 'Çevrimdışı'
      error: 'Hata'
      connecting: 'Bağlanıyor'
      disconnecting: 'Bağlantı kesiliyor'
    error:
      init_failed: 'Geçersiz SIP hesap formatı.'
      connection_failed: 'SIP proxy sunucusuna bağlanılamadı.'
      registration_failed: 'Kayıt işlemi gerçekleştirilemedi. Lütfen girdiğiniz bağlantı ayrıntılarının doğru olup olmadığını kontrol edin.'
  c:
    client_tags:
      buttons:
        start_editing: 'Etiketleri düzenle'
        finish_editing: 'Düzenlemeyi bitir'
        group_editing: 'Grup Düzenleme'
        group_add: 'Tüm Müşterilere Etiket Ekle'
        group_delete: 'Tüm Müşterilerin Etiketlerini Sil'
      notification:
        title: 'Tamamlandı'
        message: 'Müşterilerin etiketleri güncellendi'
    client_table:
      last_order_date: 'Son sipariş tarihi: {{date}}'
      average_check: 'Ortalama tutar'
    account_photo:
      upload: 'Fotoğraf yükle'
    add_tag_button:
      add_button: 'Ekle'
      add_text: '«{{q}}» Ekle'
      placeholder:
        search: 'Etiket bul'
    banner_photo:
      intro: 'Fotoğrafı sürükleyip bırakın veya yüklemeye basın'
      no_photo: 'Fotoğraf yüklenmedi'
      drop_photo: 'Yüklenecek fotoğrafı bırak'
      upload: 'Yükle'
    advert_photo:
      intro: "Fotoğrafı sürükleyin veya yükle'ye tıklayın"
      no_photo: 'Fotoğraf yüklenmedi'
      drop_photo: 'Fotoğrafı yüklemek için bırakın'
      upload: 'Yükle'
    billing_operation_table_row:
      invoice: '{{date}} tarihinde para çekim işlemi yapılacaktır'
      invoice_with_act: '{{date}} tarihinde hizmet sağlanmıştır'
      invoice_date: '{{date}} tarihinde fatura oluşturulmuştur'
      download_act: 'Muhasebe belgesi indir'
      download_invoice: 'Ödeme için fatura yükleyin'
      currency: 'Rub.'
    carrier_item:
      available_in: 'Mevcut olan şehirler:'
      rating:
        speed: 'Hız'
        price: 'Fiyat'
        quality: 'Kalite'
      connected: 'Bağlandı'
      carrier_sent: 'Talep<br>gönderildi'
      carrier_sent_hover: 'Tekrar talep<br>gönder'
      connect: 'Bağlan'
    client_card:
      no_name: 'İsimsiz müşteri'
      address: 'Müşteri adresi'
      blacklisted: 'Kara listeye alınan müşteri'
      client_comment: 'Müşteri yorumu'
      bonuses:
        none: 'Müşterinin bonusu yok'
        one: 'Müşterinin hesabında {{count}} bonus puanı var'
        few: 'Müşterinin hesabında {{count}} bonus puanı var'
        many: 'Müşterinin hesabında {{count}} bonus puanı var'
      save: 'Kaydet'
      add_comment: 'Müşteri hakkında yorum ekle'
    client_order_block:
      order_contents: 'Sipariş içeriği'
      item_amount: 'ad.'
    clients_table_row:
      is_blacklisted: 'Kara listeye alınan müşteri'
      last_order_date: 'Son sipariş tarihi: {{date}}'
  error_page:
    header: 'Veri yükleme hatası'
    comment: 'Bu genellikle, verilerin şu anda mevcut olmadığı bir siparişi veya diğer bilgileri açmaya çalıştığınızda olur.'
    back_button: 'Ana sayfaya dön'
  themes:
    title: 'Konu seçimi'
    back_button: 'Geri'
    publish_button: 'Yayınla'
    change_theme: 'Konuyu değiştir'
    common_settings: 'Genel ayarlar'
    theme_settings: 'Konu ayarları'
    not_configurable: 'Bu konunun yapılandırma parametreleri yok'
    reset_button: 'Ayarları Sıfırla'

    notifications:
      publish:
        title: 'Yayınlandı'
        message: '{{theme}} restoran web sitesinde yayınlandı'
      reset: 
        title: 'Başarılı'
        message: '{{theme}} ayarları başarıyla sıfırlandı'
        
    confirms:
      reset: 'Ayarları sıfırlamak, tüm kullanıcı tercihlerini silecek. Devam edilsin mi?'


  client_edit:
    header:
      title: 'Müşteri #'
      first_order: 'İlk sipariş:'
      order_history: 'Sipariş geçmişi'
      activity: 'Müşteri etkinliği'
      tabs:
        history: 'Sipariş geçmişi'
        bonuses: 'Bonuslar'
    form:
      avatar:
        label: 'Fotoğraf'
      name:
        label: 'Ad'
        placeholder: 'Ad'
      phone:
        label: 'Telefon'
        placeholder: 'Telefon'
        call: 'Ara'
      email:
        label: 'E-mail'
        placeholder: 'E-mail'
      bonuses:
        label: 'Bonuslar'
        placeholder: 'Bonus miktarı girin'
        add: 'Hesapla ve ekle'
        substract: 'Çek'
        amount:
          none: 'Müşterinin bonusu yok'
          one: 'Müşterinin hesabında {{count}} bonus puanı var'
          few: 'Müşterinin hesabında {{count}} bonus puanı var'
          many: 'Müşterinin hesabında {{count}} bonus puanı var'
        count:
          none: ''
          one: '{{count}} bonus'
          few: '{{count}} bonus'
          many: '{{count}} bonus'
          other: '{{count}} bonus'
      issue:
        label: 'Kod oluştur'
      birthday:
        label: 'Doğum günü'
      tags:
        label: 'Etiketler'
      recurrence:
        label: 'Geri dönme'
      comment:
        label: 'Yorum'
        placeholder: 'Yorum'
      black_list:
        label: 'Kara liste'
        control: 'Kara listeye ekle'
        caption: 'Bu müşterinin siparişleri özel bir şekilde işaretlenecektir.'
        comment: 'Kara listeye eklenme sebebi'
        listed_by: 'Kim ve ne zaman kara listeye gönderdi'
    history:
      header: 'Sipariş geçmişi'
      new_order: 'Yeni sipariş'
      change_balance: 'Bakiyeyi değiştir'
      cancel_balance_change: 'İptal'
    buttons:
      save: 'Kaydet'
      delete: 'Sil'
      close: 'Kapat'
  dish_edit:
    photo:
      tabs:
        main: 'Ana Foto'
        additional: 'Ek Fotoğraflar'
    photo_help: "Fotoğrafı sürükleyin veya yükle'ye tıklayın"
    no_photo: 'Yemek fotoğrafı yüklenemedi<br> Sitede görüntülenecek bir fotoğraf yükleyin'
    buttons:
      save: 'Kaydet'
      delete: 'Sil'
      cancel: 'İptal'
    availability:
      title: 'Restoranda mevcut olan yemekler'
      about_availability: 'Burada restoran menüsünden bir yemeği gizleyebilirsiniz ya da yemeğin mevcut olup olmadığının telefonla açıklığa kavuşturulmasını gerektirdiğini belirtebilirsiniz'
      no_available: 'Geçici olarak mevcut değil'
      need_call: 'Telefonla netleştir'
    configurator:
      new_configurator_title: 'Yeni yapılandırıcı #{{ordinal}}'
      buttons:
        add_new_group: 'Tamamlayıcı kelime grubu ekle'
        delete_configuration: 'Yapılandırmayı sil'
        configuration_settings: 'Yapılandırmayı ayarla'
        add_new_configuration: 'Yapılandırma ekle'
      labels:
        base_price: 'Temel fiyat'
      configuration_settings: 'Yapılandırmayı ayarla'
      add_new: 'Pozisyon ekle'
      base_price_caption: 'Yapılandırılmış bir yemeğin toplam fiyatını hesaplamaya başlamak için kullanılır'
      groups_zero_data: 'Henüz hiçbir yapılandırma grubu eklenmedi'
      multiple_select:
        title: 'Birden fazla seçenek seçebilirsiniz'
        min: 'Minimum'
        max: 'Maksimum'
        about: 'Seçenekler'
      zero_data:
        title: 'Oluşturulan yapılandırma yok'
        caption: 'Müşteriye yemek parametrelerini seçme imkanı vermek için bir yapılandırma ekleyin. Yapılandırma örneği; sos, katkı veya porsiyon miktarı seçimi olabilir'
    header:
      edit: 'Yemeği düzenle'
      readonly: 'Yemek seçenekleri'
      tabs:
        configurator: 'Yapılandırıcı'
        prices: 'Restoran fiyatları'
      configurator:
        edit: 'Yapılandırıcı'
        readonly: 'Yapılandırıcı (sadece görüntüleme)'
    form:
      ingridients: 'İçerik'
      calories: 'Kaloriler'
      proteins: 'Proteinler'
      fats: 'Yağlar'
      carbs: 'Karbonhidratlar'
      title:
        app: 'Web Sitesi ve Uygulama'
        description: 'Açıklama'
        integrations: 'Entegrasyonlar'
        promos: 'Promosyonlar ve Bonuslar'
        additional: 'Ekstralar'
      name:
        label: 'Yemek adı'
        placeholder: 'Yemek adı'
      price:
        label: 'Fiyat'
        placeholder: 'Fiyat'
      weight_price:
        label: '{{unit}} başına fiyat'
        placeholder: '{{unit}} başına fiyat'
      price_weight_unit:
        label: 'Fiyat hesaplaması için ölçü birimleri'
        placeholder: ''
      weight:
        label: 'Ağırlık'
        placeholder: 'Ağırlık'
      weight_unit:
        label: 'Ölçü birimi'
        placeholder: ''
      excise_unit:
        label: 'Özel tüketim vergisi niteliği'
        placeholder: ''
      external_id:
        label: 'Harici kod (id)'
        placeholder: 'id'
        caption: "Smartomato widget'ını entegre ederken kullanılır"
      description:
        label: 'Açıklama'
        placeholder: 'Açıklama'
      category:
        label: 'Kategori'
      suggesting:
        label:
          on: 'Tavsiye için öncelik'
          off: 'Bu yemek tavsiye edilsin mi?'
        priority: 'Öncelik'
        disable: 'Devre dışı bırak'
        caption: "Ek satışlar için çok sayıda yemek belirleyebilirsiniz, daha sonra öncelikler Smartmato'nun tavsiye için en uygun olanı seçmesine izin verecektir."
        enable: 'Yemeği ek satışa dahil et'
      disabled_sources:
        label: 'Toplayıcılara yükleme yasağı'
        caption: 'Belirli bir toplayıcı veya birkaç toplayıcı için bir yemeğin satışını yasaklayabilirsiniz'
      extras:
        label: 'Ekstralar'
        is_list: 'Metin olarak göster'
        can_zoom: 'Yakınlaştırılabilir'
        is_hidden: 'Menüyü gizle'
        is_bonus_only: 'Sadece bonusla alınan yemekler'
        no_bonus_accrue: 'Bu yemek için bonus kullanma'
        dont_discount: 'Bu yemekte indirim yapmayın'
        prohibit_takeaway: 'Kendin gel al seçeneği için yemeği yasakla'
        prohibit_delivery: 'Teslimat seçeneği için yemeği yasakla'
        is_popular: 'Popüler yemeklerden oluşan bir blokta gösterin'
        restrict_bonus_withdrawal: 'Bu yemek için ikramiye kesilmesini yasaklayın'
        is_required: 'Gerekli yemek'
      is_next_day:
        label: 'Ertesi gün teslimat'
        toggle: 'Ertesi gün teslimat yapılan yemek'
        hour_count: 'Ertesi günün başlangıcından itibaren geçen saat sayısı'
        caption: "Varsayılan olarak, böyle bir yemeğin olduğu siparişler, bir sonraki günün başlangıcına aktarılacak ve teslimat bölgelerinden zaman almaya devam edecektir.<br><br>Ancak teslimat gece yarısından sonra gerçekleşirse bu tür yemekler 00:01'e aktarılacaktır.<br><br> Saat sayısı, zamanı belirtilen saat sayısı kadar ileri almanıza olanak tanır. <br><br>Zamanı tüm organizasyon için global olarak (bunun için sohbet bölümünde bize yazın) veya her yemek için ayrı ayrı ayarlayabilirsiniz."
      is_metric:
        label: 'Ağırlık yemeği'
        toggle: 'Ağırlıkla birlikte yemek'
      min_qty:
        weight: 'Minimum ağırlık ({{unit}})'
        volume: 'Minimum hacim ({{unit}})'
      delta_qty:
        weight: 'Ağırlık artışı ({{unit}})'
        volume: 'Hacim artışı ({{unit}})'
      old_price:
        label: 'Eski fiyat'
        placeholder: 'Eski fiyat'
        caption: 'Bu fiyat sitede çizilmiş olarak gösterilecektir'
      cooking:
        time:
          label: 'Hazırlanma süresi'
          placeholder: 'Süre'
          caption: 'Yemek hazırlama programını hesaplamak için dakika cinsinden hazırlama süresi.<br>Teslimat alanından hazırlama süresini kullanmanız gerekiyorsa boş bırakın'
          unit: 'dk'
        line:
          label: 'Atölye'
          caption: 'Yemeğin hazırlanacağı üretim hattı'
      tags:
        label: 'İşaretler'
        placeholder: 'Vejetaryen, Düşük kalorili, Baharatlı'
        caption: 'Virgülle ayrılmış kelimeler belirtebilirsiniz, bu tür kelimelerin her biri sitede bir işaret haline gelecektir.'
      meta_title:
        label: 'Meta title'
        placeholder: 'meta title'
      meta_description:
        label: 'Meta description'
        placeholder: 'meta description'
    prices:
      price:
        label: 'Fiyat'
        is_hidden: 'Menüde yok'
        is_default: 'Varsayılan olarak şu anki fiyatlar ve bulunma durumu'
        override: 'Geçersiz kıl'
      base_price:
        label: 'Yapılandırıcı temel fiyatı'
      disable: 'Farklı fiyatları devre dışı bırak'
      zero_data:
        header: 'Farklı restoranlarda fiyatlar ve bulunma durumları'
        caption: 'Yemek şu anda tüm restoranların menüsüne aynı fiyata dahildir'
        enable: 'Farklı fiyatlar veya mevcut olma durumu belirtin'
  category_edit:
    new: 'Yeni kategori'
    header:
      edit: 'Kategori düzenleme'
      readonly: 'Kategori seçenekleri'
    form:
      disclaimer: '＊ Yalnızca bazı temalarda desteklenir'
      name:
        label: 'Kategori adı'
        placeholder: 'Kategori adı'
      external_id:
        label: 'Harici kod (id)'
        placeholder: 'id'
        caption: 'Restoran muhasebe sistemleri ile entegre edilirken kullanılır'
      description:
        label: 'Açıklama'
        placeholder: 'Açıklama'
      parent:
        label: 'Ebeveyn kategorisi'
      export_hidden:
        label: 'Toplayıcılara gizli dışa aktarma'
      disabled_sources:
        label: 'Agregatörlere İhraç Yasağı'
        caption: 'Bir kategorinin belirli bir agregatöre veya birden fazla agregatöre ihraç edilmesini engelleyebilirsiniz'  
      extras:
        label: 'Ekstralar'
        is_list: 'İçeriği metin olarak görüntüle (yalnızca bazı dış görünümlerde)'
        is_hidden: 'Menüyü gizle'
        age_restriction: 'Yaş sınırlaması'
        toggle_hidden_recursively: 'Restoranlarda tüm yemekleri gizle/göster'
        toggle_hidden_restaurant_id: 'Bir restoran seçin'
        toggle_hidden:
          true: 'Gizle'
          false: 'Göster'

      meta_title:
        label: 'Meta title'
        placeholder: 'meta title'
      meta_description:
        label: 'Meta description'
        placeholder: 'meta description'
    buttons:
      save: 'Kaydet'
      delete: 'Sil'
      cancel: 'İptal'
  reports:
    sidebar:
      report_type: 'Hesap türü'
      add_filter: 'Filtre ekle'
      condition_and: 'koşul veya'
      condition_or: 'koşul ve'
      remove_filter: 'Filtre sil'
      choose: 'Seçin'
      group_by: 'Gruplandır'
      execute_button: 'Tamamla'
    content:
      loading: 'Rapor oluşturuluyor...'
      zero_data:
        header: 'Rapor tasarımcısı'
        caption: "Gerekli rapor türünü seçin, filtreleri kullanarak koşulları ayarlayın ve 'Tamamla' ya tıklayın."
  orders:
    sidebar:
      filters:
        status: 'Durum: '
        restaurant: 'Restoran: '
        zone: 'Bölge: '
        courier: 'Kurye: '
        date: 'Teslim Tarihi: '
        zeroData: 'Filtreler seçilmedi'
        elepsis: 've diğer filtreler'
      now: 'Şimdi'
      later: 'Daha sonra'
      all: 'Tümü'
      placeholders:
        search: 'Akıllı arama'
      sections:
        is_bk: 'Kuryeler için yiyecekleri hariç tut'
        status: 'Sipariş durumu'
        date_range: 'Teslimat süresi'
        separator: 'ile'
        client_rate: 'Müşteri değerlendirmesi'
        restaurants: 'Restoranlar'
        deliveryZones: 'Teslimat bölgesi'
        assigned_couriers: 'Atanmış kuryeler'
        order_sources: 'Sipariş kaynağı'
        payment_sources: 'Ödeme kaynağı'
        payment_status: 'Çevrimiçi ödeme durumu'
        archive_orders: 'İki haftadan eski siparişleri göster'
        orders_count: 'Gösterilen siparişler {{ordersLength}} / {{ordersCount}}'
        delivery_types: 'Teslimat türü'
    table:
      no_number: 'Numara yok'
      no_text: 'Belirtilmemiş'
      assign_courier: 'Ata'
      order_change: 'Para üstü'
      content:
        status: 'Durum'
        published_at: 'Geldi'
        restaraunt: 'Restoran'
        client: 'Müşteri'
        address: 'Adres'
        client_rate: 'Değerlendirme'
        tag: 'Kategori'
        pos_status: 'POS durumu'
        delivery_at: 'Teslimat'
        courier: 'Kurye'
        payment_source: 'Ödeme'
        final_sum: 'Sipariş tutarı'
        source: 'Kaynak'
        delivery_zone: 'Bölge'
        loading: 'Siparişleri yüklüyoruz'
        zero_data:
          archive_not_found: 'Sipariş yok'
          archive_limited: 'Son iki hafta ile sınırlı seçim'
          archive_limited_caption: 'Arşivlenmiş siparişlere erişmek için filtre panelindeki "İki haftadan eski siparişleri görüntüle" anahtarını etkinleştirin'
  courier_apps:
    header: 'Kurye uygulamasını yükleme zamanı!'
    comment_start: 'Smartomato kuryesi olarak oturum açmışsınız gibi görünüyor. Bölümde size atanan siparişleri göreceksiniz'
    orders_button: 'Siparişler'
    comment_end: ', ancak bunları onaylayamaz ve teslimat işlemlerini yönetemezsiniz.'
    setup_application: 'Siparişlerinizi yönetmek için Android kurye uygulamasını yükleyin veya tabletler için uyarlanmış çevrimiçi sipariş yönetimi arayüzüne gidin.'
    button_ios_app: 'iOS Mobil uygulaması'
    button_android_app: 'Android Mobil uygulaması'
    button_mobile_app: 'Tabletler için web arayüzü'
    goto_orders: 'Sipariş bölümüne git'
  clients:
    client_card:
      registered: 'Kayıtlı {{when}}'
      lastorder: 'Son sipariş {{when}}'
      birthdate: 'Doğum günü {{when}}'
      card: 'Sadakat kartı: №{{number}}'
    clients_count:
      one: 'Müşteri'
      few: 'Müşteri'
      many: 'Müşteri'
      other: 'Müşteri'
    bonuses_count:
      one: 'Bonus'
      few: 'Bonus'
      many: 'Bonus'
      other: 'Bonus'
    filter:
      smart_search: 'Akıllı arama'
      tags: 'Etiketler'
      no_tags_message: 'Henüz etiketiniz yok, bunları müşteri kartına ekleyin ve kategorisini tanımlayın.'
      dishes: 'Sipariş edilen yemekler'
      recurrence: 'Geri dönme'
      order_status: 'Sipariş durumu'
      sources: 'Kaynaklar'
      organizations: 'Kuruluşlar'
      cities_restaurants: 'Şehirler (restoranlara göre)'
      unrestricted: 'Sınırsız'
      restaurants: 'Restoranlar'
      order_period: 'Sipariş dönemi'
      average_check: 'Ortalama tutar'
      orders_count: 'Sipariş miktarı'
      black_list: 'Kara liste'
      from: 'от'
      to: 'до'
    index:
      sort_by: 'Sırala:'
      found: 'Bulundu'
      recurrence_change_dynamics: 'Geri dönme değişikliği dinamikleri'
      percent: 'yüzde'
      absolute: 'Kesinlikle'
      loading: 'Müşterileri yüklüyoruz'
      nothing_found: 'Müşteri bulunamadı'
      nothing_found_comment: 'Filtreleme seçeneklerini değiştirmeyi deneyin'
    client_type:
      new:
        one: 'Yeni'
        few: 'Yeni'
        many: 'Yeni'
        other: 'Yeni'
      active:
        one: 'Aktif'
        few: 'Aktif'
        many: 'Aktif'
        other: 'Aktif'
      returned:
        one: 'Geri dönen'
        few: 'Geri dönen'
        many: 'Geri dönen'
        other: 'Geri dönen'
      cold:
        one: 'Pasif'
        few: 'Pasif'
        many: 'Pasif'
        other: 'Pasif'
      dead:
        one: 'Kaybedilmiş'
        few: 'Kaybedilmiş'
        many: 'Kaybedilmiş'
        other: 'Kaybedilmiş'
    recurrence_filter:
      new: 'Yeni'
      active: 'Aktif'
      returned: 'Geri dönen'
      cold: 'Pasif'
      dead: 'Kaybedilmiş'
    recurrence_label:
      new: 'Yeni'
      active: 'Aktif'
      returned: 'Geri dönen'
      cold: 'Pasif'
      dead: 'Kaybedilmiş'
    recurrence_label_long:
      new: 'Yeni müşteri'
      active: 'Aktif müşteri'
      returned: 'Geri dönen müşteri'
      cold: 'Pasif müşteri'
      dead: 'Kaybedilmiş müşteri'
    recurrence_comment:
      new: 'Müşteri ilk siparişini verdi'
      active: 'Müşteri 2 haftadan uzun süredir düzenli olarak sipariş veriyor'
      returned: 'Müşteri tekrar sipariş vermeye başladı'
      cold: 'Müşteri 2 haftadan uzun süredir sipariş vermemiş'
      dead: 'Müşteri 1 aydan uzun süredir sipariş vermemiş'
    order_source:
      delivery_club: 'Delivery Club'
      foodfox: 'Yandex.Yemek'
      obed_ru: 'Obed.ru'
      broniboy: 'Broniboy'
      chibbis: 'Chibbis'
      glovo: 'Glovo'
      vk: 'Vk'
      sbermarket: 'Sbermarket'
      external_site: 'Harici site'
      external_site_mobile: 'Harici site (Mobil vesiyon)'
      marketplace: 'Vitrin'
      marketplace_mobile: 'Vitrin (Mobil versiyon)'
      board: 'Board'
      mobile_application_ios: 'iOS uygulaması'
      mobile_application_android: 'Android uygulaması'
      iiko: 'iiko'
      external_aggregator: 'Harici toplayıcı'
    orders:
      one: 'Sipariş'
      few: 'Sipariş'
      many: 'Sipariş'
      other: 'Sipariş'
    sort:
      orders_count: 'Sipariş sayısına göre'
      average_check: 'Ortalama kontrole göre'
      created_at: 'Kayıt tarihine göre'
      bonus_count: 'Bonus bakiyesine göre'
  date:
    today: 'Bugün'
    tomorrow: 'Yarın'
    yesterday: 'Dün'
    by: 'к'
    at: 'в'
    during: 'içinde'
    during_days:
      one: '{{count}} gün'
      few: '{{count}} gün'
      many: '{{count}} gün'
      other: '{{count}} gün'
    during_hours:
      one: '{{count}} saat'
      few: '{{count}} saat'
      many: '{{count}} saat'
      other: '{{count}} saat'
    during_minutes:
      one: '{{count}} dakika'
      few: '{{count}} dakika'
      many: '{{count}} dakika'
      other: '{{count}} dakika'
    during_seconds:
      one: '{{count}} saniye'
      few: '{{count}} saniye'
      many: '{{count}} saniye'
      other: '{{count}} saniye'
  billing:
    form:
      header: 'Faturalandırma planı ayarları'
      set_payment_method: 'Ödeme yöntemi seçin'
      empty_subheader: 'Tarife planı, servisin kullanımıyla ilgili kısıtlamaları etkiler.'
      current_tariff: ' Mevcut tarifeniz «{{tariff}}»'
      unit: 'rub./Ay'
      change_tariff: 'Tarifeyi değiştir'
      payment_method: 'Abonelik ödeme yöntemi'
      change_payment_method: 'Ödeme yöntemini veya bilgileri değiştirin'
      state:
        normal:
          header: 'Tümü ödendi'
          comment: 'Sonraki ödeme {{date}}'
        free:
          header: 'Ücretsiz tarife'
        invoices:
          header: 'Ödenecek miktar {{sum}} руб.'
          comment: '{{date}} tarihine kadar ödenmesi gerekiyor'
        dept:
          header: 'Ödenecek miktar {{sum}} руб.'
          comment: 'Servis {{date}} tarihine kadar kullanılabilecek'
        blocked:
          header: 'Kuruluş bloke edildi'
          comment: 'Bloke işlemi {{date}} tarihinde yapıldı'
        paywall:
          header: 'Deneme süresi'
          comment: '{{date}} tarihine kadar deneme süresi mevcut. Bitmeden önce bir tarife planı seçin.'
        paywall_deadline:
          header: 'Deneme süresi doldu'
          comment: 'Deneme süresi sona erdi. Lütfen devam etmek için bir plan seçin.'
      choose_tariff: 'Tarife planı seçin'
      choose_tariff_and_setup_payment: 'Bir tarife planı seçin ve bir ödeme yöntemi ayarlayın'
      pay_button_dept: 'Bakiye yükle'
      pay_button: 'Öde'
      operations:
        header: 'Hesap işlemleri geçmişi'
        table:
          date: 'Tarih'
          operation: 'İşlem'
          sum: 'Tutar'
      balance:
        label: 'Hesabınızdaki tutar'
        currency: 'Rub.'
    payment_method:
      header: 'Smartomato ödeme yöntemini ayarla'
      comment: 'Abonelik için hesaptan veya banka kartı ile ödeme yapabilirsiniz.'
      tabs:
        card: 'Banka kartı'
        bank_account: 'Hesap'
      bank_details:
        header: 'Kuruluş bilgileri:'
        payer_name:
          label: 'Tüzel kişilik adı'
          placeholder: '"Los Pollos Hermanos" LTD.'
        inn:
          label: 'VKN'
          placeholder: ''
        kpp:
          label: 'KPP'
          placeholder: ''
        address:
          label: 'Kanuni adres'
          placeholder: 'Faturalandırma için gerekli'
        settlement_account:
          label: 'Hesap'
          placeholder: ''
        corresponding_account:
          label: 'Muhabir hesap'
          placeholder: ''
        bik:
          label: 'BIC'
          placeholder: ''
        bank_name:
          label: 'Banka adı'
          placeholder: ''
        signer:
          label: 'İmzalayan, Adı, Soyadı'
          placeholder: 'Ivanov I.I.'
        role:
          label: 'İmzalayan, görevi'
          placeholder: 'Genel Müdür'
        act_subheader: 'Sağlanan hizmetler ile ilgili belge oluşturulması için veriler'
    tariffs:
      header: 'Size en uygun tarife planını seçin'
      subheader: 'Planınızı istediğiniz zaman değiştirebilirsiniz'
      change_tariff:
        plain: '{{tariff_name}} tarifesine geç'
        paywall: 'Tarife planını kullanmaya başlayın'
        paywall_before_deadline: 'Servisi tarife planında kullanmaya başlayın'
    warnings:
      trial_period: 'Şu anda deneme süresi mevcut. {{deadline}} tarihine kadar bir tarife planı seçin.'
      paywall_warning: '{{deadline}} deneme süresi sona eriyor. Bloke olmamak için bir tarife planı seçin.'
      paywall_expired: 'Deneme süresi sona erdi. Lütfen devam etmek için bir plan seçin.'
      free_tariff: 'Ücretsiz tarife planında bulunuyorsunuz, site sipariş işlemi çalışmıyor'
      blocked: 'Ödeme yapılmadığı için kuruluş bloke oldu, siteden sipariş alma işlemi çalışmıyor'
      rush_mode_restaurants: "🔥 Bazı restoranlarda yüksek talep modu etkinleştirilmiştir: {{total}}'dan {{disabled}}"
      blocked_restaurants: "🔒 Bazı restoranlar sipariş alma engellendi: {{total}}'dan {{disabled}}"
      dept_detected: 'Borcunuz mevcut, bloke olmayı önlemek için {{son tarih}} tarihine kadar {{sum}} ödeyin'
      pending_invoices: "{{deadline}} tarihinden önce 'Smartomato' servisini kullanmak için {{sum}} ödemeniz gerekir"
    notifications:
      change_tariff_error: 'Hata'
  order:
    status_mini_popup:
      client_notification_type_call: 'Bir müşteriyi aramanız gerekiyor'
      annotation: 'Siparişin mevcut ilerlemesini yönetin'
      cancel_reason: 'İptal nedeni belirtiniz'
      placeholders:
        cancel_reason_comment: 'İptal nedeni belirtiniz'
      buttons:
        change_status: 'Durum değiştir'
        open_history: 'Değişiklik geçmişine bak'
    map_popup:
      warning:
        order_unpaid: '⚠️ SİPARİŞ HENÜZ ÖDENMEDİ'
        order_expired: '⚠️ SİPARİŞ SÜRESİ GEÇTİ'
      order_name: 'Sipariş No:{{order}}'
      takeaway: 'Kendin gel al'
      delivery_price: 'Teslimat tutarı {{currency}}'
      delivery_free: 'Ücretsiz teslimat'
      payment_source: '{{paymentSource}}'
      choose_self_courier: 'Kurye seç'
      time:
        cooking_start: 'Yemek hazırlamaya başla'
        pick_up_at: 'Sipariş teslim al'
        delivery_at: 'Sipariş teslim et'
        shelf_time: 'Siparişin geçerlilik süresi'
      outsource:
        outsource_courier: 'Atanan kurye'
        no_delivery_request: 'Teslimat siparişi henüz verilmedi'
        outsource_courier_pickup_time: 'Kurye varış zamanı:'
        outsource_delivery_price: 'Teslimat harici tedarik fiyatı:'
        outsource_messages: 'Mesajlar'
      buttons:
        confirm: 'Siparişi onayla'
        dispose: 'Siparişi kaldır'
      client_notification_type_call: 'Bir müşteriyi aramanız gerekiyor'
    courier_mini_popup:
      external_delivery: 'Sipariş, {{externalDelivery}} harici tedarik kaynaklıdır'
      selected_courier:
        courier_free: 'Kurye serbest'
        distance: 'Restorana kadar olan mesafe'
        order_number: 'Sipariş No:{{order}}'
        no_address: 'Adres yok'
        picked_up_at: 'Alındı'
        pick_up_at: 'Alım (plan)'
        delivery_at: 'Teslimat zamanı'
      annotation:
        choose_self: 'Siparişi teslim edecek bir kurye seçin'
        non_created_outsource: '{{external Delivery}} adresindeki harici kurye teslimat başvurusu oluşturulmadı'
        confirm_create_outsource: '{{externalDelivery}} içinde sipariş yerleşimini onaylayın'
        cancel_courier_assign: 'Kuryenin atamasını kaldırmak için ikinci kez tıklayın'
        external_courier: 'Devam ederseniz, {{externalDelivery}} için harici kurye kullanımı iptal edilecektir.'
        self_courier: 'Kendi kuryenize sipariş verebilirsiniz'
        cancel_self_before_place: "Harici kaynak kullanımı için siparişi {{externalDelivery}}'e aktarmak için, kendi kuryenizden iptal edin"
      buttons:
        back: 'Geri'
        cancel_outsource_delivery: 'Harici kaynak kullanım iptalini onaylayın'
        cancel: 'İptal'
        place_outsource: 'Talep gönderin'
    time_mini_popup:
      annotation: 'Sipariş işlem zaman aralıklarını belirtin'
      section:
        cooking_start_at: 'Yemek hazırlamaya başla'
        pick_up_at: 'Sipariş teslim al'
        delivery_at: 'Sipariş teslim et'
      takeaway: 'Kendin gel al'
      order_name: 'Sipariş #{{order}}'
      payment_source: '{{paymentSource}}'
      time:
        cooking_start: 'Yemek hazırlamaya başla'
        delivery_at: 'Sipariş teslim et'
      buttons:
        confirm: 'Siparişi onayla'
        save: 'Kaydet'
    feasibility_warnings:
      transportation_time: 'Sipariş zamanında teslim EDİLEMEYEBİLİR. Gelmesi gereken zaman {{transportation_time}} dk., Size teslim edileceği zaman {{trans_time}} dk.'
      cooking_time: 'Sipariş zamanında HAZIRLANAMAYABİLİR. {{cooking_time}} dakika sürmesi gerekiyordu, ama sizde {{cook_time}} dakika sürüyor.'
    problems:
      is_past_delivery_end_deadline: 'Sipariş zamanında teslim edilmedi'
      is_past_delivery_start_deadline: 'Sipariş kuryeye zamanında teslim edilmedi'
      is_past_cooking_end_deadline: 'Sipariş zamanında hazırlanmadı'
      is_past_cooking_start_deadline: 'Yemek hazırlamaya zamanında başlanmadı'
      is_past_confirm_deadline: 'Sipariş zamanında onaylanmadı'
      is_past_payment_deadline: 'Sipariş hala ödenmedi'
      is_past_courier_deadline: 'Kurye zamanında atanmadı'
      is_past_restaurant_confirm_deadline: 'Restoran siparişi onaylamadı'
    payment_method:
      cash: 'Nakit'
      card: 'Online kartla'
      courier_card: 'Kartla kuryeye'
      delivery_club_card_online: 'Sitede DeliveryClub ile'
      external_service_card_online: 'Harici hizmette online olarak'
      extra_bonuses: ' + bonuslar'
    pos_status:
      pending: 'Sevkiyat için bekleniyor'
      error: 'Sevkiyat hatası'
      success: 'İhracat başarısı'
    delivery_type:
      takeaway: 'Kendin gel al'
      delivery: 'Kurye ile teslimat'
      dine_in: 'Yemek' # Google translate

    asap_type:
      specified_time: 'Belirtilen zamanda'
      asap: 'Mümkün olan en kısa sürede'
    status:
      draft: 'Taslak'
      pending: 'Yeni'
      confirm: 'Onaylandı'
      preparing: 'Hazırlanıyor'
      prepared: 'Hazırlandı'
      delivery: 'Kuryede'
      complete: 'Teslim edildi'
      undo: 'İptal'

    scheduled: '{{when}} zamanında atandı'
    takeaway: 'Kendin gel al'
    dine_in: 'Yemek' # Google translate

    bonus_card:
      title: 'Bonus ve İndirimler'
      discount: 'Sipariş indirimi'
    content:
      edit:
        item_free: 'Hediye'
    summary:
      items_sum: 'Sipariş'
      delivery_price: 'Teslimat'
      used_bonuses: 'Bonus puanı'
      discount_sum: 'İndirim'
      commission_sum: 'Komisyon'
    edit:
      do_time_update: 'Kalan zaman noktalarında ayarlamalar yapalım mı?'
      configurator:
        comment: 'Yorumlar'
        labels:
          total_price: 'Toplam'
        placeholders:
          comment: 'Ek istekler'
      order_now_viewing: 'Siparişe şu an bakanlar:'
      draft_status_notice: "Taslak sipariş durumunu yönetemezsiniz. Siparişi 'Yeni' durumuna aktarmak için 'Yerleştir' düğmesini kullanın"
      normal_header: 'Sipariş #{{number}}'
      draft_header: 'Taslak sipariş'
      order_content_header: 'Sipariş içeriği'
      published_at: '{{when}} yerleştirildi'
      reset_change: 'Para üstü gerekli mi?'
      client_search: 'Müşteri aranıyor...'
      new_client: 'Bu müşteri henüz veritabanınızda yok'
      edit_order: 'Düzenle'
      finish_editing: 'Bitir'
      delete_confirm: 'Siparişi silmek istediğinizden emin misiniz?'
      payment:
        warning: '⚠️ Sipariş henüz ödenmedi.'
        success: '✅ Sipariş ödendi'
      sync:
        synced: '{{when}} sipariş kaydedildi'
        syncing: 'Kaydediliyor...'
        error: 'Kaydetme hatası!'
      history:
        empty_history: 'Değişiklik geçmişi yok'
        loading_text: 'Geçmiş yükleniyor...'
      delivery_zone:
        minimal_order_price: 'Minimum sipariş:'
        delivery_time: 'Teslimat zamanı: '
        free_delivery_price: 'Ücretsiz kargo limiti:'
        time_unit: 'dk.'
        delivery_price: 'Teslimat fiyatı:'
      labels:
        status: 'Durum'
        restaurant: 'Restoran'
        comment: 'Yorumlar'
        change: 'Para üstü miktarı'
        use_bonuses: 'Bonusla öde'
        payment: 'Ödeme'
        qr_payment_status: 'QR aracılığıyla ödeme durumu'
        takeaway: 'Kendin gel al noktası'
        when_delivery: 'Teslim et'
        when_pickup: 'Siparişi gönder'
        client_delivery_at: 'Müşteriye ne zaman teslim edilsin'
        cooking_start_at: 'Hazırlamaya ne zaman başlansın'
        table: 'Masa' # Google Translate
        delivery_at: 'Ne zaman gönerilsin'
        pick_up_at: 'Restorandan ne zaman alınsın'
        client:
          phone: 'Telefon'
          name: 'Ad'
          rate: 'Müşteri değerlendirmesi'
        delivery_type: 'Teslimat türü'
        city: 'Şehir'
        delivery_address: 'Teslimat adresi'
        delivery_zone: 'Teslimat bölgesi'
        delivery_price: 'Teslimat fiyatı'
        use_promo_code: 'Promosyon kodu belirt'
        courier: 'Kurye'
        use_delivery: 'Teslim et'
        tag: 'Kategori'
        pos_status: 'POS durumu'
        staff_comment: 'Personel yorumu'
        cutlery: 'Kaşık çatal seti adedi'
      buttons:
        add_dish: 'Yemek ekle'
        close: 'Kapat'
        place: 'Yerleştir'
        more_details: 'Daha fazla detay göster'
        only_statuses: 'Sadece durum göster'
      placeholders:
        address: 'Adres'
        apartment: 'Daire'
        floor: 'Kat'
        staircase: 'Giriş'
        address_comment: 'Adrese yorum ekle'
        buddy_name: 'Ad girin'
      hints:
        geocode_order: 'Teslimat alanını tanımlayın'
      dish_selection:
        title: 'Yemek seçin'
        nothing_found: 'Hiçbir şey bulunamadı'
        is_hidden: 'Menüde gizli'
        buttons:
          back: 'Geri'
        placeholders:
          search: 'Yemek ara'
      bonus_amount:
        none: ''
        one: 'Kullanılabilir: {{count}} bonus puanı'
        few: 'Kullanılabilir: {{count}} bonus puan'
        many: 'Kullanılabilir: {{count}} bonus puan'
  monitor:
    notifications:
      common_title: 'Sipariş #{{number}} — {{name}}'
      new_order_title: 'Yeni sipariş geldi #{{number}}'
      paid: 'Sipariş #{{number}} ödendi'
      confirm_deadline: '{{when}} sipariş geldi, ama henüz onaylanmadı'
      cooking_start_deadline: 'Sipariş {{when}} zamanında hazırlanmaya başlanmalıydı {{when}}, ama hala «{{status}}» durumunda'
      cooking_end_deadline: 'Sipariş {{when}} zamanında hazır olmalıydı, ama hala «{{status}}» durumunda'
      delivery_start_deadline: 'Sipariş {{when}} zamanında kuryede olmalıydı, ama hala «{{status}}» durumunda'
      delivery_end_deadline: 'Sipariş {{when}} zamanında gönderilmiş olmalıydı, ama hala «{{status}}» durumunda'
      payment_deadline: 'Sipariş ödemesi henüz yapılmadı'
      courier_deadline: 'Restorandan sipariş alınıyor {{when}}, kurye henüz atanmadı'
      status_changed: 'Sipariş durumu «{{status}}» olarak değiştirildi'
      courier_confirmed: 'Kurye {{courier_name}} siparişi onayladı'
      restaurant_confirmed: '{{restaurant_name}} tarafından sipariş onayı alındı'
      just_created: 'Siparişi onaylayın {{when}}'
      restaurant_confirm_deadline: 'Sipariş hala restoran tarafından onaylanmadı'
      cooking_start: 'Yemek hazırlamaya başla. Restorandan sipariş alınıyor {{when}}'
      active_order: 'Bekleyen siparişle çalışmaya başlandı, teslimat {{when}}'
      delayed_order: "Sipariş 'Beklemede' kategorisine taşındı."
  configurator:
    confirm:
      remove_group_binding: 'Grup bağlantısı kaldırılsın mı?'
      remove_modifier_scheme: 'Çanak yapılandırıcı kaldırılsın mı?'
    validations:
      single_select: '{{groupName}}: Tam olarak bir seçenek seçmelisiniz'
      multiple_select: '{{groupName}}: {{min}} ila {{max}} arasındaki seçeneklerinden birini seçmelisiniz'
  currency: '{{price}} Rub.'
  dashboard:
    sidebar:
      done_title: 'Restoranın web sitesini çalışmaya başlamak için hazırla'
      done_caption: 'Harika! Siteniz çalışmaya başlamaya hazır. Satışlarınızı nasıl artıracağınızı ve verimliliğinizi nasıl yükselteceğinizi yakında anlatacağız.'
      header: 'Restoranın web sitesini çalışmaya başlamak için hazırla'
      progress: 'Tamamlandı {{done}}/{{total}}'
    main:
      zero:
        title: 'Restoran İstatistikleri'
        text: 'Şimdiye kadar, gerçek satış dinamiklerini, en yüksek çalışma zamanlarını ve siparişlerin sıklık haritasını göstermek için yeterli bilgiye sahip değiliz'
        disclaimer: 'Demo bilgileri'
      range:
        week: 'Hafta'
        month: 'Ay'
        year: 'Yıl'
    dynamics:
      orders_summary:
        one: 'Sipariş'
        few: 'Sipariş'
        many: 'Sipariş'
        other: 'Sipariş'
      revenue: 'Toplam gelir'
      average_check: 'ortalama tutar'
      header: 'Sipariş dinamikleri'
      pie_chart_caption: 'Müşterilerin geri dönüş yapısı'
      bar_chart:
        header: ' Gün içindeki en yoğun saatler'
        work_days: 'Hafta içi'
        weekends: 'Tatil günleri'
        whole_week: 'Tüm hafta'
      baskets:
        map_header: 'Sipariş haritası'
        dishes_header: 'Popüler yemekler'
        loading: 'Veriler yükleniyor...'
        dish_unit: 'ad..'
  sm_select:
    placeholder:
      zero: 'Hiçbir şey seçilmedi'
      one: '{{count}} öğe seçildi'
      few: '{{count}} öğe seçildi'
      many: '{{count}} öğe seçildi'
      other: '{{count}} öğe seçildi'
  staff:
    roles:
      admin: 'İdareci'
      regional_admin: 'Bölgesel İdareci (franchising)'
      manager: 'Yönetici'
      manager_logist: 'Lojistik yöneticisi'
      logist: 'Lojistik'
    notifications:
      order_created: 'Yeni sipariş'
      order_restaurant_confirmed: 'Restoran tarafından sipariş kabul edildi'
      order_courier_confirmed: 'Kurye sipariş onayı'
      order_cooking_start: 'Mutfağa gelen sipariş'
      billing_event: 'Smartomato hizmet ödemesi'
      negative_rate_received: 'Siparişle ilgili olumsuz bir değerlendirme alma'
      restaurant_running_changed: 'Restoranı açma veya kapatma'
      pos_order_export_error: 'Kasiyere sipariş gönderirken hata alma'

  staff_table:
    is_me: 'Bu sizsiniz'
    in_restaurant: 'Restoranda'
  checklist:
    theme_selected: 'Site dizaynı seçin'
    menu_filled: 'Birkaç yemek ekleyin'
    has_delivery_zones: 'Bölgeyi ve teslimat koşullarını ayarlayın'
    has_couriers: 'Kuryeleri ekleyin'
    has_address_phone: 'Restoranın telefon numarasını ve adresini girin'
    has_domain: 'Domen seçin'
    is_published: 'Siteyi yayınlayın'
  menu:
    sandbox: 'UI'
    organizations: 'Kuruluşlar'
    analytics: 'Web analizi ve SEO'
    restaurants: 'Restoranlar'
    couriers: 'Kuryeler'
    delivery: 'Teslimat'
    dishes: 'Menü'
    themes: 'Site'
    orders: 'Siparişler'
    billing: 'Tarife planı'
    profile: 'Profil ayarları'
    staff: 'Çalışanlar'
    business_role: 'İş rolleri'
    sip: 'Telefon'
    support: 'Yardım'
    clients: 'Müşteriler'
    promos: 'Promosyon'
    map: 'Harita'
    organization_settings: 'Kuruluş ayarları'
    organization_settings_header: 'Ayarlar'
    payment_methods: 'Sipariş ödeme yöntemi'
    integrations: 'Entegrasyon'
    integrations_settings:   'Entegrasyon ayarları'
    logout: 'Çıkış'
    utilities: 'Ekstralar'
    interface: 'Arayüz ayarı'
    reports: 'Raporlar'
    promo_constructor: 'Promosyonlar'
    loyalty_programs: 'Sadakat programları'
    ads_and_push: 'Reklam ve toplu e-posta bülteni'
    banners: 'Afişler'
    client_tags: 'Etiketler'
  login:
    please_authorize: 'Lütfen, giriş yapın'
    login_placeholder: 'Kullanıcı adı'
    password_placeholder: 'Şifre'
    sign_in: 'Giriş'
    cant_login: 'Giriş başarısız oldu!'
    label_restore_password: 'Şifre sıfırlama talimatlarını içeren bir e-posta göndereceğimiz e-posta adresinizi girin'
    mail: 'E-posta'
    send_password: 'Şifre gönder'
    cancel: 'İptal'
    login: 'Kullanıcı adı'
    password: 'Şifre'
    password_restore_was_send: 'E-postanıza şifre sıfırlama talimatları içeren bir e-posta gönderildi'
    captcha_error: 'Hata! Robot olmadığınızı onaylayın.'
    sign_up_link: 'Kayıt olun,'
    sign_up_link_comment: 'Hesabınız yok mu'
    restore_button: 'Şifrenizi mi unuttunuz?'
  notifications:
    organization_saved:
      title: 'Kaydedildi'
      message: 'Kuruluş başarıyla kaydedildi.'
    restaurant_saved:
      title: 'Kaydedildi'
      message: 'Restoran başarıyla kaydedildi.'
    restaurant_error:
      title: 'Hata'
      message_fallback: 'Restoran kaydedilirken bir hata oluştu'
    restaurant_destroy_error:
      title: 'Silinemedi'
      message_fallback: 'Bu restoranın teslimat bölgeleri ve siparişleri içermediğini kontrol edin'
  categories:
    published_at: 'Son yayınlama {{date}} {{time}}'
    not_published: 'Menü henüz yayınlanmadı'
    publish: 'Menüyü yayınla'
    add_category: 'Kategori girin'
    edit_placeholder: 'Ad girin'
    upload_photo: 'Fotoğraf yükle'
    delete_category: 'Kategori sil'
    add_dish: 'Yemek ekle'
    zero_data:
      header: 'Kategori seçilmedi'
      caption: 'Ayrıntılı bilgileri görüntülemek veya düzenlemeye başlamak için bir kategori seçin.'
    editConfigurator: 'Yapılandırıcı ayarları'
    confirm:
      save_before_photo: 'Fotoğrafı yüklemeden önce kategoriyi kaydetmeniz gerekiyor. Kaydetmek?'
      delete: 'Kategori silinsin mi? Kategorideki tüm yemekler silinecek.'
    new_configurator:
      categories: 'Kategoriler'
      modifiers: 'Tamamlayıcı kelimeler'
      help: 'Tamamlayıcı kelimeler, onlara belirli bir özellik veya pişirme özelliği katan yemeklerin özellikleridir (örneğin, «tuzsuz», «limonlu» vb.). <br> <br> Tamamlayıcı kelimeler, kutuda iş yemeği, hamburger veya noddle için yapıcı olarak kullanıma uygundur'
  modifier_groups:
    buttons:
      add: 'Ekle'
      edit: 'Düzenle'
    condition:
      minmax: 'Miktar gereksinimi'
      view_type: 'Farklı göster'
      prompt: 'Teşvik edici form'
    title: 'Tanımlayıcı ayarları'
  delivery:
    menu:
      couriers: 'Kuryeler'
      zones: 'Teslimat bölgeleri'
      own_couriers: 'Kendi kuryeleri'
    outsource:
      statuses:
        canceled: 'İptal edildi'
        idle: 'Talep yok'
        claim_created: 'Kurye arama'
        courier_assigned: 'Kurye atandı'
        delivering: 'Teslimat devam ediyor'
        delivered: 'Teslim edildi'
        problem: 'Problem'
        pickup_arrived: 'Kurye geldi'
    zone:
      providers:
        own: 'Hayır'
        dostavista: 'Dostavista'
        yandex_go: 'Yandex.Go'
  restaurants:
    tarif_restriction:
      title: 'Restoran limiti aşıldı'
      message: 'Tarife planınızı değiştirin veya güncel olmayan kuruluşları kapatın'
    add_restaurant: 'Restoran ekle'
    no_group: 'Gruplandırma olmadan'
    remove_button: 'Sil'
    cancel_button: 'İptal'
    save_button: 'Kaydet'
    remove_confirm: 'Restoran silinsin mi?'
    cancel_confirm: 'Değişiklikler iptal edilsin mi?'
    validate_name_phone_address: 'İsim, telefon numarası ve adres boş bırakılmamalıdır!'
    zero_data:
      message: 'Restoran seçilmedi'
      hint: 'Ayrıntılı bilgileri görüntülemek veya düzenlemeye başlamak için bir restoran seçin.'
    edit:
      is_new: 'Yeni restoran ekleme'
      form_title: 'Aşağıdaki formu doldurun ve kaydet düğmesine tıklayın'
      normal_mode_text: 'Normal mod etkin'
      normal_mode_caption: 'Teslimat bölgesindeki standart ayarlar kullanılacaktır'
      not_running: 'Kuruluş çalışmıyor'
      not_running_caption: 'Bu kuruluş için siparişleri kabul etmeye başlamak amacıyla açın.'
      common_destroy: 'Ortak silme'
      common_destroy_caption: 'Restoranı zorla kaldırmak için etkinleştirin.'
      force_destroy: '⚠️ Zorla silme ⚠️'
      force_destroy_caption: 'Zorunlu silme durumunda, bu restoranla ilgili tüm siparişlerin ve teslimat bölgelerinin de silineceğini lütfen unutmayın.<br>
                              İyileşme olasılığı olmadan!'
      timezone_caption: '⚠️ Kuruluşta {{timezone}} kurulu'
      off_reason_caption: 'Bu alanda restoranın kapatılma nedenini belirtebilirsiniz.'
      auto_enable_timezone: 'Belirtilen zaman geldiğinde, bu restoran için sipariş verme otomatik olarak etkinleştirilecek ve yöneticilere bir e-posta bildirimi gönderilecektir.'
      labels:
        name: 'Ad'
        phone: 'Telefon'
        address: 'Adres'
        city: 'Şehir'
        description: 'Açıklama'
        availability: 'Sipariş erişebilirliği'
        rush_mode: 'Yüksek talep modu'
        is_delivery: 'Çalışma saatleri'
        deletion: 'Silme'
        location: 'Konum'
        timezone: 'Restoran saat dilimi'
        external_id: 'Harici kod'
        terminal_id: 'Terminal Kimliği'
        off_reason: 'Kapatılma nedeni'
        auto_enable: 'Restoran ne zaman otomatik olarak açılır'
        address_comment: 'Adres yorumu'
        parent_restaurant: 'Ana restoran'
      placeholders:
        name: 'Ad girin'
        phone: 'Telefon numarası girin'
        address: 'Sokak adı girin'
        city: 'Şehir girin'
        location: 'Adres için bir açıklamaya ihtiyacınız varsa (bir teslimat harici kaynak sağlayıcısı ile entegrasyon yaparken kullanılır)'
        timezone: 'Restoran saat dilimi'
        external_id: 'Harici servislerle entegrasyon için gerekli'
        terminal_id: 'Harici servislerle entegrasyon için gerekli'
        off_reason: 'Neden belirtin'
        description: 'Uygulamada ve web sitesinde restoran sayfası için açıklama'
        address_comment: 'Adres için bir açıklamaya ihtiyacınız varsa (bir teslimat harici kaynak sağlayıcısı ile entegrasyon yaparken kullanılır)'
      is_running: 'Kuruluş çalışıyor'
      is_running_caption: 'Bu kuruluşta sipariş almayı durdurmak için kapatın. Kapatılmış restoranlar tarife kısıtlamalarına dahil edilmez.'
      rush_mode_text: '🔥 Yüksek talep modu etkin'
      rush_mode_caption: 'Bu mod için teslimat bölgesinden özel ayarlar kullanılacaktır'
      is_delivery_text: 'Müşteri adresini göster'
      is_delivery_hint: 'Restoran yalnızca teslimat yapan bir restoransa ve müşterilerin adresini bilmesi gerekmiyorsa bu onay kutusunu kapatın.. Bu durumda haritada işletmeyi göreceksiniz ve müşteriler sadece telefon numarasını görecekler.'
  organizations:
    add_button: 'Ekle'
    delete_button: 'Sil'
    cancel_button: 'İptal'
    save_button: 'Kaydet'
    validate_name_host: 'Ad ve Host alanı boş bırakılmamalıdır'
    cancel_confirm: 'Değişiklikler iptal edilsin mi?'
    remove_confirm: 'Kuruluş silinsin mi?'
    zero_data:
      message: 'Kuruluş seçilmedi'
      hint: 'Ayrıntılı bilgileri görüntülemek veya düzenlemeye başlamak için bir kuruluş seçin.'
    name:
      label: 'Ad'
      placeholder: 'Girin '
    phone:
      label: 'Telefon'
      placeholder: 'Telefon numarası girin'
    host:
      label: 'Domen'
      placeholder: '*.smartomato.ru alt alan adını girin'
    login:
      label: 'Kullanıcı adı girin'
      placeholder: 'Kullanıcı adı'
    password:
      label: 'Şifre'
      placeholder: 'Şifre girin'
    about:
      label: 'Açıklama'
      placeholder: 'Açıklama'
  zone_templates:
    header: 'Teslimat koşulu ekleyin'

    switch:
      delivery: 'Kurye teslimatı'
      takeaway: 'Kendin gel al'
      dine_in: 'Yemek' # Google Translate

    # TODO translate from English
    new_object_default_name:
      dine_in: 'Dine-in conditions'
      delivery: 'New delivery zone'
      takeaway: 'Takeaway point'

    header_description: 'Kurye teslimat bölgeleri veya kendin gel al noktaları ekleyebilirsiniz'
    draw_description: 'Ön ayarlı olan bölgelerden hiçbiri size uymuyorsa, kendi bölgenizi çizebilirsiniz'
    draw_description_no_templates: 'Bölgeyi ayarlamak için haritayı kullanın'
    draw_button: 'Bölge çiz'
    choose_zone_header: 'Şablonlardan birini kullanın'
    choose_zone_placeholder: 'Ara'
    nothing_found: 'Bölge bulunamadı'
    draw_zone_header: 'Haritada bölge çizin'
    add_takeaway: 'Kendin gel noktası oluşturun'
    takeaway_note: 'Bu restoranda kendin gel noktası oluşturmak için minimum sipariş, noktanın çalışma modu ve hazırlanma süresi gibi çalışma koşullarını ayarlamanız gerekir.'

    # TODO translate from English
    dine_in_note: 'To enable dine-in in this restaurant you should set the conditions: the restaurant\'s working hours and some other parameters'
    add_dine_in: 'Add dine-in conditions'

  orders_map:
    no_current:
      title: 'Mevcut sipariş yok'
      text: 'Bu, yeni siparişleri veya işlenmesi gereken siparişleri içerecektir.'
    no_delayed:
      title: 'Bekleyen sipariş yok'
      text: 'Buraya, müdahalenizi henüz gerektirmeyen siparişler gelecektir'
    courier_popup:
      statuses:
        offline: 'Çalışmıyor'
        free: 'Serbest'
        delivering: 'Siparişi <strong>{{address}}</strong> adresine teslim ediyor'
        picking_up_order: "Sipariş için <strong>{{restaurant}}</strong>'a gidiyor>"
  history:
    change_name:
      delivery_price: 'Teslimat tutarı'
      delivery_at: 'Teslimat zamanı'
      cooking_start_at: 'Hazırlama başlangıcı'
      status: 'Durum'
      courier_id: 'Kurye'
      pick_up_at: 'Alma saati'
      contact_name: 'Ad'
      contact_phone: 'Telefon'
  import:
    status:
      free: 'Serbest'
      upload: 'Yükle'
      queued: 'Sırada'
      working: 'Yerine getiriliyor'
  modifier_group:
    edit:
      back_button: 'Geri'
      header: ''
      subheader: 'Tanımlayıcı grupları'
      photo:
        label: "Modifikatör Fotoğrafı"
        upload: "Fotoğraf Yükle"
      name:
        label: 'Ad'
        placeholder: 'Tanımlayıcı kelime grup adları'
      visible:
        label: 'Görüntüle'
      prompt:
        label: 'Kullanım önerisi'
        placeholder: 'Örneğin, «Kızartma derecesi seçin»'
      minmax:
        label: 'Adet sınırı'
      min:
        label: 'En az'
      max:
        label: 'En fazla'
      view_type:
        label: 'Nasıl görüntülenir'
        checkbox: 'Checkbox'
        select: 'Select'
        stepper: 'Stepper'
      external_id:
        label: 'Harici ID'
        placeholder: 'ID'
      modifiers:
        new_modifier: 'Yeni değiştirici'
        restaurant_price: '{{restaurant}} fiyatı ({{priceUnit}})'
        header: 'Tanımlayıcı setleri'
        comment: 'Olası seçeneklerin listesini belirtin'
        default: 'Varsayılan'
        name:
          label: 'Ad'
          placeholder: "Örneğin, 'Medium rare'"
        price:
          label: 'Fiyat'
          placeholder: '—'
        external_id:
          label: 'Harici ID'
          placeholder: '—'
      buttons:
        save: 'Kaydet'
        delete: 'Sil'
        cancel: 'İptal'
        add: 'Tanımlayıcı kelime ekle'
  general_parameters:
    labels:
      site_name: 'Siteye bu adresten ulaşılabilir'
      site_name_caption: 'Site adresini "Kuruluş ayarları" bölümünden değiştirebilirsiniz.'
      organization_logo: 'Logo'
      organization_name: 'Kuruluş adı'
      organization_about: 'Kuruluş açıklaması'
  promos:
    buttons:
      add: 'Ekle'
    zero_data:
      active: 'Henüz aktif promosyonlar yok'
      archive: 'Henüz arşiv promosyonlar yok'
    zero_data_caption:
      active: 'Ortalama tutar veya sipariş sıklığını artırmak için promosyonlar ekleyin'
      archive: 'Ortalama tutar veya sipariş sıklığını artırmak için promosyonlar ekleyin'
    edit:
      back_button: 'Geri'
      header: 'Promosyon düzenleme'
      subheader: "Aşağıdaki formu doldurun ve lütfen kaydet'i tıklayın"
      name:
        label: 'Ad'
        placeholder: 'Promosyon adı'
      description:
        label: 'Açıklama'
        placeholder: 'Açıklama'
      offer_description:
        label: 'Kullanım önerisi'
        placeholder: 'Promosyonun kullanılabilmesi durumunda müşteriye görünecek metin'
      is_working:
        label: 'Promosyon aktif'
        caption: 'Promosyon eylemini geçici olarak devre dışı bırakmanıza olanak tanır. Aktif olmayan promosyonlar müşterilere gösterilmeyecektir.'
      period:
        label: 'Geçerlilik süresi'
        to: 'kadar'
      for_birthday:
        label: 'Doğum günü promosyonu'
        before_birthday: 'Doğum gününden önce aktif'
        after_birthday: 'Doğum gününden sonra aktif'
        placeholder: 'gün sayısı'
        caption: 'Doğum günü promosyonu, doğum gününden belirli sayıda gün önce ve sonra etkinleştirilebilir'
      timetable:
        enabled: 'Program etkin'
        disabled: 'Program kapalı'
      timetable_for_order_time:
        label: 'Sipariş zamanını dikkate alın'
        caption: 'Belirlenen zaman çizelgesi, siparişin verildiği zamana değil, siparişin verildiği zamana uygulanacaktır'
      timetable_for_asap_only:
        label: 'Yalnızca acele siparişler için sipariş zamanını dikkate alın'
        caption: 'Bekleyen bir emir olması durumunda, emrin verildiği zaman yerine emrin verildiği zaman kullanılacaktır'
      priority:
        label: 'Promosyon önceliği'
        placeholder: 'pozitif tamsayı'
        caption: 'Promosyonların nasıl yönetileceğini kontrol etmek için öncelik gereklidir.<br> Misafire birkaç promosyon uygunsa, en yüksek önceliğe sahip bir veya daha fazlası seçilecektir.'
      is_exclusive:
        label: 'Promosyon birbirini dışlar'
        caption: 'Aynı önceliğe sahip birden fazla promosyonun tek bir sırada kullanılmasını yasaklamanızı sağlar.'
      sources:
        label: 'Sipariş kaynaklarında sınırlama'
        unrestricted: 'Promosyon tüm sipariş kaynakları için geçerlidir'
        restricted_header: 'Lütfen dikkat!'
        restricted_comment: 'Sipariş kaynaklarındaki kısıtlamalar nedeniyle, promosyon yalnızca listede belirtilen kaynaklardan sipariş veren müşterilere sunulacaktır.'
      restaurants:
        label: 'Restoran sınırlaması'
        unrestricted: 'Promosyon tüm restoranlar için geçerlidir'
        restricted_header: 'Lütfen dikkat!'
        restricted_comment: 'Restoranlar üzerindeki kısıtlama nedeniyle, promosyon yalnızca restoran belirlendikten sonra (adresi girdikten veya bir teslim alma noktası seçtikten sonra) müşteri için görünür olacaktır.'
      inversed_delay: 'varsayılan olarak kapalı'
      disposable: 'tek kullanımlık'
      for_referral: 'davet (referral) için'
      is_takeaway: 'Kendin al için uygun'
      is_delivery: 'Teslimat için uygun'
      is_dine_in: 'Restoranda yemek yemek için uygundur'
      free_delivery: 'Ücretsiz kargo'
      not_delivery_takeaway_warning: 'Promosyonun geçerli olabilmesi için, sipariş alma ile ilgili en az bir yönteme uygun olmalıdır'
      last_order:
        header: '«Son sipariş»'
        comment: 'Belirtilen gün sayısı için en az bir sipariş almış olan misafirlere, en az belirtilen tutar için olacak bir promosyon yapabilirsiniz'
        days_count:
          label: 'Gün sayısı:'
          placeholder: 'Gün sayıs:'
        sum:
          label: 'Minimum sipariş tutarı:'
          placeholder: 'Tutar'
      single_use_codes:
        header: 'Tek seferlik promosyon kodu'
        comment: 'Promosyonda, promosyonu içerecek bir dizi kod tanımlayabilirsiniz. Her kod yalnızca bir kez kullanılabilir.'
        enabled:
          label: 'Tek seferlik kod'
          caption: 'Her biri yalnızca bir kez kullanılabilen bir dizi gizli kod oluşturabilirsiniz.'
        stat:
          label: 'Promosyona eklenen kod sayısı'
          report: 'Kod kullanım raporu'
          download: 'Kodları İndir (.csv)'
          used: 'Bunlardan kullanılanlar'
          available: 'Kullanım için hazır'
          delete_unused: 'Kullanılmayan kodları sil'
        create:
          title: 'Promosyon kodları oluştur'
          title_more: 'Ek promosyon kodları oluştur'
          amount: 'Miktar'
          length: 'Kod uzunluğu'
          button: 'Üret'
          comment: 'Belirli kurallara göre tek seferde bir kod grubu oluşturabilir, kaç koda ihtiyacınız olduğunu ve kaç karakter uzunluğunda olması gerektiğini belirleyebilirsiniz. Karakterler ne kadar çok olursa, müşterinin onları alma olasılığı o kadar düşük olur, bunları yazmak bir o kadar zor olur.'
          generate: 'Kod oluştur'
          cancel: 'Kod oluşturma'
          need_save: 'Oluşturma, promosyonu kaydettikten sonra kullanılabilir olacak'
      promos_issue:
        header: 'Müşterilere manuel ve otomatik kod verilme işlemi'
        comment: 'Bu promosyonu müşterilerin bu promosyona erişmek için kodlar gönderebilecekleri şekilde yapılandırmak için etkinleştirin'
        enable:
          label: 'SMS bildirimi ile kodların verilmesini etkinleştirin'
        issue_sms_text:
          label: 'SMS mesaj metni'
          placeholder: 'Metin'
          example:
            label: 'Örnek:'
            text: '[name], Siparişin geç teslim edilmesinden dolayı özür olarak size pizza hediye etmek istiyoruz, lütfen bir sonraki siparişinizde [code] kodunu belirtiniz.'
        length:
          label: 'Kod uzunluğu'
          placeholder: 'Karakter miktarı'
          caption: 'Karakterler ne kadar çok olursa, müşterinin onları alma olasılığı o kadar düşük olur, bunları yazmak bir o kadar zor olur.'
        ttl:
          label: 'Her kodun ömrü, gün'
          placeholder: 'Gün'
          caption: 'Belirtilen gün sayısından sonra kod silinecektir.<br>0 - Kodları asla silme.'
        manual_enable: 'Müşterilere manuel olarak kod verilmesine izin ver'
      issue_late:
        header: 'Gecikme bonusu'
        comment: 'Bu promosyonu, geç teslim edilen her sipariş için, müşteriye bu promosyondan tek seferlik bir kod içeren bir SMS gönderilecek şekilde ayarlayabilirsiniz.'
        enable:
          label: 'Gecikme bonusu etkinleştir'
        minutes_amount:
          label: 'Gecikme olarak sayılacak miktar, min:'
          placeholder: 'dk.'
      codes:
        header: 'Çok seferlik promosyon kodları'
        comment: 'Promosyonu içerecek bir kod belirleyebilirsiniz.'
        code:
          label: 'Çok seferlik promosyon kodu'
          placeholder: 'Gizli kod'
          caption: 'Promosyon için promosyon kodu ayarlarsanız, misafirler sipariş verirken kodu belirtebilir. Kod, promosyonun diğer koşullarıyla birleştirilebilir. Bu kod ile istediğiniz sayıda sipariş verebilirsiniz.'
      error_text:
        label: 'Misafirler için hata metni'
        placeholder: 'Misafirler için hata metni'
        caption: 'Misafir doğru kodu girerse ancak promosyon kriterleri karşılamıyorsa, belirtilen metin kendisine gösterilecektir.'
      required_all_dishes:
        header: 'Siparişte belirtilen tüm yemeklerin bulunma durumu'
        comment: 'Örneğin, Tavuk burger, patates kızartması ve Cole Slow salatası sipariş ederken yanında ücretsiz bir içecek,'
        label: 'Yemek listesi'
      required_any_dish:
        header: 'Siparişte belirtilen listeden bir veya daha fazla yemek bulunma durumu'
        comment: 'Örneğin, etli, biberli veya mantarlı dört pizza sipariş ederken yanında ücretsiz bir içecek'
        label: 'Yemek listesi'
        number: 'Yemek listesindeki miktar'
      required_any_dish_categories:
        header: 'Belirtilen kategorilerden bir veya daha fazla yemeğin siparişte bulunması'
        label: 'Kategori listesi'
      client_requirements:
        header: 'Müşteri gereksinimleri'
        category:
          label: 'Müşteri kategorileri'
          caption: 'Müşteri, belirtilen kategorilerden birine ait olmalıdır'
        restrict_category:
          label: 'Belirli müşteri kategorilerini yasakla'
          caption: 'Müşteri, listelenen kategorilerden herhangi birine sahip olmamalıdır'
        order_sum:
          label: 'Sipariş tutarı'
        repeatable_bonus:
          label: 'Bir siparişte birden çok kez kullanılabilir'
          caption: 'Örneğin, <em>«Siparişinizdeki her burger için ücretsiz bir içecek verin»</em>'
        for_new_client:
          label: 'Yeni müşteri promosyonu'
          caption: 'Promosyon, henüz tek bir siparişi olmayan bir müşteri için geçerli olacaktır.'
        nth_order:
          label: 'Sipariş numarası'
          caption: 'Faturada belirtilen her müşteri siparişi için bir indirim düzenlemenize olanak tanır, sipariş sayısı promosyon süresi boyunca korunur'
      bonuses:
        header: 'Bonuslar'
        comment: 'Siparişteki promosyonun uygulanmasının sonucunu belirler'
        bonus_dishes:
          label: 'Belirtilen yemekleri siparişe ekleyin'
        bonus_price:
          label: 'Bonus yemeklerin tutarı'
          caption: 'Eğer hediye yemekleri ücretsiz değil, özel bir fiyata vermek istiyorsanız'
        bonus_free_dishes:
          label: 'Belirtilen yemeklerden birini seçmeyi teklif edin'
        discount_percent:
          label: 'Siparişte yüzdelik indirim'
        discount_fixed:
          label: 'Sabit sipariş indirimi'
        discount_dishes_percent:
          label: 'Koşullar altında belirtilen yemekler için yüzdelik indirim'
          caption: 'Tüm sipariş için değil, yalnızca belirli yemekler için indirim düzenlemenize olanak tanır.'
          single_dish: 'Listeden sadece bir yemek için'
          cheapest:
            caption: 'Varsayılan olarak, indirim en yüksek fiyata sahip yemeğe uygulanacak. Ama değiştirmek mümkündür.'
            enable: 'En ucuz yemekte indirim yap'
        assign_tag:
          label: 'Kullanıcıya kategori atama'
        reset_tag:
          label: 'Varsa, müşterinin belirtilen kategorilerini sıfırlayın'
        issue_code:
          label: 'Promosyondan kodu oluşturun ve gönderin'
      buttons:
        save: 'Kaydet'
        delete: 'Sil'
        cancel: 'İptal'
    add_promo: 'Promosyon ekle'
    headers:
      index: 'Promosyon listesi'
      active: 'Aktif promosyonlar'
      archived: 'Promosyon arşivi'
    during_last_days:
      one: 'Son {{count}} gün içinde en az 1sipariş oldu'
      few: 'Son {{count}} gün içinde en az 1sipariş oldu'
      many: 'Son {{count}} gün içinde en az 1sipariş oldu'
      other: '«Son {{count}}» gün içinde en az 1sipariş oldu'
  promo_card:
    buttons:
      edit: 'düzenle'
    condition:
      dish_discount: 'Promosyon yemeklerinde indirim'
      next_order_in_days: 'Son sipariş için bonus:'
      next_order_min_sum: ' az olmayan bir miktar için '
      actual_from: 'Gerçekleştirme süresi:'
      restaurants_selected: 'Restoranlar:'
      restaurants_all: 'Tüm restoranlar'
      promo_code: 'Promosyon kodu:'
      it_free: 'Hediye'
      order_discount: 'Sipariş indirimi'
      actual_till: 'Promosyon sona erdi:'
      copy: 'Bağlantıyı kopyala'
      copied: 'Bağlantı kopyalandı'
  banners_index:
    header: 'Vitrin afişleri ve uygulama'
    create_button: 'Ekle'
    zero_data:
      header: 'Henüz banner\'larınız yok'
      caption: 'Misafirlerinize web sitesinde veya mobil uygulamada bazı bilgiler vermek için banner\'ları kullanabilirsiniz'
  banners:
    disabled_text: 'Üzgünüz, <br>banners özelliğini kullanamazsınız'
    back_button: 'Geri'
    title: 'Afişi düzenle'
    main:
      name:
        label: 'başlık'
        placeholder: 'Banner başlığı (dahili kullanım için)'
      view_order:
        label: 'Görüntüleme sırası: '
        placeholder: 'Sayısal sıra (1, 2, 3...)'
        zero: 'ayarlanmamış'
      url_web: 'Vitrin için bağlantı'
      url_mobile: 'Uygulama için bağlantı'
      kind:
        label: 'Afişin gösterileceği yer: '
        placeholder: 'Platform seçin'
        web: 'Vitrinde'
        mobile: 'Uygulama İçi'
        zero: 'ayarlanmamış'
      photo:
        label: 'Resim'
      restaurants:
        label: 'Restoranlara kısıtlama'
      is_archived:
        label: 'Afişi gizle'
      termps:
        label: 'son kullanma tarihi'
        to: 'kadar'
      has_clickable_popup: 'Tıklanabilir popup'
      has_popup_on_start: 'Başlangıçta açılan popup'
      popup_with_image:   'Resimli açılır pencere'
      popup_is_blocking: 'Engelleyen popup'
      popup_title: 'Popup başlığı'
      popup_content: 'Popup metni'
      cancel_button: 'İptal düğmesi için metin'
      confirm_button: 'Onay düğmesi için metin'
      type:
        title: 'İçerik türü'
        link: 'Link'
        popup: 'Popup'
  adverts_index:
    header: 'Reklam ve toplu e-posta bülteni'
    create_button: 'Ekle'
    is_private: 'Gizli'
    zero_data:
      header: 'Henüz reklamınız yok'
      caption: 'Reklamların yardımıyla, sitede, push mesajıyla veya başka bir şekilde misafirlere bazı bilgiler verebilirsiniz'
  adverts:
    disabled_text: 'Ne yazık ki, <br>reklam işlevselliği sizin için kullanımda değil'
    back_button: 'Geri'
    title: 'Reklam düzenleme'
    menu:
      main: 'Genl bilgiler'
      preview: 'Ön görünüm'
      delivery: 'Toplu e-posta'
      stats: 'İstatistik'
    main:
      name:
        label: 'Ad'
        placeholder: 'Reklam başlığı'
      text:
        label: 'Metin'
        placeholder: 'Ayrıntılı metin'
      action:
        label: 'Bağlantı-eylem'
        placeholder: 'Düğmeden bağlantı'
      photo:
        label: 'Resim'
      is_private:
        label: 'Yayınlanmamış promosyon'
        on_comment: 'Şimdi bu duyuru, yalnızca postanın gönderildiği kişilere doğrudan bir bağlantı aracılığıyla görünür olacaktır.'
        off_comment: 'Artık siteye veya uygulamaya giren herkese bu reklam gösterilecek'
      is_archived:
        label: 'Reklamı gizle'
      terms:
        label: 'Geçerlilik süresi'
        to: 'kadar'
    preview:
      link: 'Duyuru bağlantısı:'
    delivery:
      intro: 'Bir e-posta listesi başlatmak için bu reklamın gönderileceği müşterileri seçin.<br>rekla bülteni, SMS ile hemen gerçekleştirilebilir veya önce bir push bildirimi ile denenebilir ve daha sonra sms ile denenebilir.'
      restaurants:
        label: 'Restoran sınırlaması'
        placeholder: 'Restoranları sınırlama'
      recurrence:
        label: 'Geri dönme sınırlaması'
        placeholder: 'Tümü'
      were_orders:
        label: 'Dönemde en az bir sipariş oldu'
        from: 'с'
        to: 'по'
      were_no_orders:
        label: 'Dönem boyunca sipariş olmadı'
        not_yet: 'Şimdilik bu kriter çalışmıyor'
        from: 'с'
        to: 'по'
      send_push:
        label: 'Push-bildirim'
        caption: 'iOS- ve Android uygulamasında Push-bildirim'
      send_sms:
        label: 'SMS'
        caption: 'Push bildirimi belirli bir süre açık kalırsa, bu müşteriye SMS gönderilmeyecektir.'
      text_sms:
        label: 'SMS mesaj metni'
        caption: 'Metne bir bağlantı yerleştirmek için bu formda ayrı bir alanda belirtin ve şablonun kendisinde
          <code>{link}</code> kullanın. Ardından, postalama sırasında bunun yerine her alıcı için benzersiz bir
          bağlantı oluşturulacaktır. Bu, e-posta dönüşümünü hesaplamamıza yardımcı olacaktır.
          <br>
          Bir müşterinin adını bir mesaja eklemek için [name] yapısını kullanın.'
      push_text:
        label: 'Push-bildirim metni'
        placeholder: 'Push-bildirim metni'
        caption: 'Metinde link kullanmanıza gerek yok ama emoji kullanabilirsiniz. 😉'
      push_title:
        label: 'Anlık bildirim başlığı'
        placeholder: 'Anlık bildirim başlığı'
        caption: 'Uygulama adını başlık olarak kullanmak için boş bırakın.<br>En fazla 65 karakter ayarlamanızı öneririz'
      link:
        label: 'Sms için bağlantı'
        placeholder: 'Push-bildirim metni'
        caption: 'Siteye girerken reklamın müşteriye gösterilmesini istiyorsanız, sonuna aşağıdaki kodu ekleyin:'
        notice: 'sms sayısını azaltmak ve geçiş istatistiklerini saymak için bağlantı kısaltılacaktır'
      promo:
        label: 'Promosyon, dönüşüm hesaplaması için'
        no_promos: 'Henüz bir promosyonunuz mevcut değil. Promosyon kodu içeren bir promosyon ekleyin ve buraya girin, dönüşümü hesaplamanıza yardımcı olacaktır.'
        caption: 'Seçilen promosyon kullanılarak yapılan tüm siparişler, bu duyurunun posta istatistiklerinde hedeflenmiş olarak sayılacaktır.'
      execution:
        status_label: 'Durum:'
        counting: 'Belirtilen kriterlere göre müşteri arıyoruz...'
        found: 'Belirtilen kriterlere göre bulunanlar:'
        execute_button: 'Toplu eposta bülteni başlat'
      scheduled_at:
        label: 'Bir duyuru planlayın'
      cancel:
        cancel_button: 'Reklamı iptal et'
    stats:
      header: 'Toplu e-posta istatistikleri'
      loading: 'İstatistikleri yüklüyoruz...'
      transport: 'Teslimat kanalı:'
      sent: 'Gönderilen:'
      received: 'Açık:'
      shown: 'Açık (2):'
      orders_made: 'Yapılan sipariş:'
      average_total: 'Ortalama tutar:'
      sum_total: 'Toplam gelir:'
      income_per_sent: 'Reklam başına gelir:'
      empty_stat: 'Bu ilan için henüz postalama istatistiği yok'
      empty_promo:
        header: 'Reklam hedef promosyonu belirtmedi, dönüşüm hesaplaması kesin olmayacak'
        comment: '<p>Hedef promosyon, sistemin müşterilerin bu reklama verdiği siparişleri ayırt etmesine yardımcı olur.</p><p>Dönüşüm, söz konusu promosyonun uygulandığı tüm siparişleri hesaba katacaktır</p>'
  loyalties_index:
    header: 'Sadakat Programları'
    create_button: 'Ekle'
    zero_data:
      header: 'Henüz sadakat programınız yok'
      caption: 'Sadakat programları sayesinde müşterileri indirimler veya bonuslar gibi ödüllerle çekip elde tutabilirsiniz.'
  loyalties:
    new: 'Sadakat Programı'
    disabled_text: 'Üzgünüz, sizin için sadakat programları işlevi kullanılamaz.'
    back_button: 'Geri'
    title: 'Sadakat Programını Düzenle'
    main:
      name:
        label: 'Adı'
        placeholder: 'Adı'
      kind:
        label: 'Sadakat Programı Türü: '
        zero: 'Belirtilmemiş'
  client_tags_index:
    header: 'Etiketler'
    create_button: 'Ekle'
    zero_data:
      header: 'Henüz etiketiniz yok'
  client_tag:
    new: 'Тег'
    disabled_text: 'Maalesef etiket düzenleme işlevine erişiminiz yok.'
    back_button: 'Geri'
    title: 'Etiketi Düzenleme'
    main:
      name:
        label: 'Adı'
        placeholder: 'Adı'
      assign_type:
        label: 'Koşullar yerine getirilirse'
        autoassign: 'Atamak'
        autounassign: 'Atamayı kaldır'
      period:
        label: 'Takip dönemi'
        from: 'itibaren'
        to: 'ile'
      num_of_orders: 'Dönem başına sipariş sayısı'
      spended_sum: 'Müşteri bazında döneme ilişkin gelir'
      order_frequency: 'Döneme ilişkin siparişlerin sıklığı'
      consumed_category:
        label: 'Belirli bir kategoriden yemek siparişi verme'
        non_label: 'Belirli bir kategoriden sipariş eksikliği'
      consumed_dish:
        label: 'Belirli bir yemek sipariş edin'
        non_label: 'Belirli bir yemek için sipariş eksikliği'

  courier:
    add:
      courier_list: 'Kurye listesi'
      add_button: 'Ekle'
    availability_everywhere: 'Tüm restoranlarda kurye mevcuttur'
    edit:
      buttons:
        back: 'Geri'
        assign: 'Bir kurye atayın'
        cancel_assigment: 'Kurye atamasını iptal et'
        cancel_order_in: 'Şuradaki siparişi iptal et'
        create_an_app_in: 'Bir uygulama oluştur'
      labels:
        avatar: 'Foto'
        name: 'Ad'
        phone: 'Telefon'
        login: 'Email'
        password: 'Şifre'
        repeat_password: 'Şifre onayı'
        courier_status: 'Engellenen/İşten çıkarılan'
        select_restaurant: 'Restoran sınırlaması'
        courier_comment: 'Yorum'
      placeholders:
        name: 'Ad'
        phone: 'Telefon numarası girin'
        email: 'Email girin'
        password: 'Şifre girin'
        repeat_password: 'Şifreyi tekrarlayın'
        courier_status: 'Engellenen/İşten çıkarılan'
        select_restaurant: 'Restoran sınırlaması'
        courier_comment: 'Yorum'
      toggle:
        text: "Smartomato'ya erişimi engelle"
        caption: "Bu, hesabı kaydeder ancak Smartomato'ya erişimi yasaklar"
      caption:
        download_courier_app:
          text: 'Kurye uygulamasına girmek için giriş ve şifre gereklidir. Kurye uygulaması indirin'
          ios: ' iOS için'
          android: ' Android için'
          and: 've'
      is_edit: 'Kurye düzenleme'
      is_new: 'Yeni kurye ekleme'
      form_edit_title: 'Aşağıdaki formu doldurun ve kaydet düğmesine tıklayın'
      courier_availability_about: 'Operatörün kurye ataması yaparken sadece restoranla ilişkili kuryeleri görebilmesi için kuryenin çalışmasını bazı kuruluşlarla sınırlandırabilirsiniz.'
      
      transport_type:
        label: 'Kurye Taşıma Türü'
        about: 'Kuryenin teslimatlar için kullandığı taşıma yöntemi'
        types:
          public_transport: 'Toplu taşımayla'
          walk: 'Yürüyerek'
          car: 'Araba ile'
    
    buttons:
      save: 'Kaydet'
      cancel: 'İptal'
      delete: 'Sil'
  delivery_zone:
    labels:
      dine_in_name: 'Dine-in settings name' # TODO translate from english
      takeaway_name: 'Kendin gel noktası adı'
      minimal_order_price: 'Minimum sipariş limiti ({{unit}})'
      free_delivery_price: 'Ücretsiz kargo limiti ({{unit}})'
      cooking_time: 'Hazırlanma süresi (dk.)'
      cooking_time_auto: 'Otomatik pişirme süresi hesaplama'
      delivery_zone_priority: 'Bölge önceliği'
      courier_order_fee: 'Bu bölgede sipariş teslimatı için kurye ücreti:'
      delivery_time_expand_minutes: 'Normal çalışma süresini (dk.) kadar uzatın'
      delivery_zone_name: 'Bölge adı'
      delivery_price: 'Teslimat fiyatı ({{unit}})'
      delivery_time: 'Toplam teslimat süresi (dk.)'
      transportation_time: 'Taşıma süresi (dk.)'
      outsource_provider: 'Harici kaynak kullanımıyla teslimat:'
      outsource_subsidy: 'Gönderim için sübvansiyon:'
      outsource_reject_from_price: 'Teslimat yasağı fiyat limiti:'
      outsource_free_delivery_price: 'Ücretsiz teslimat limiti:'
      service_charge: 'Servis ücreti (%):'
      fixed_service_charge: 'Sabit servis ücreti'
      delivery_zone_edit: 'Harita üzerinde teslimat bölgesinin sınırlarını belirlemek gerekir:'
    placeholders:
      no_outsource_provider: 'Hayır'
    segments:
      settings: 'Ayarlar'
      advanced: 'Ek ayarlar'
      timetable: 'Program'
    buttons:
      delete: 'Sil'
      save: 'Kaydet'
      area_edit: 'Bölgeyi düzenle'
      area_define: 'Teslimat bölgesinin sınırlarını belirleyin'
    validation:
      no_time_intervals: 'Lojistik araçlarının doğru çalışması için teslimat zaman aralıklarını belirtin'
      time_not_valid: 'Toplam teslim süresi, hazırlık süresi ile nakliye süresinin toplamından büyük olmalıdır'
    popover:
      help_timetable_text: "<p>Çalışma programı, sistemin siparişlerin verilmesine izin vereceği zamanı ayarlamanıza olanak tanır.</p> <p>Belirtilen saatte kuryeler son siparişi teslim edecek ve işi tamamlayacaktır.</p><p>Bölge ayarlarında belirtilen teslim süresine göre mutfak daha erken boşaltılacaktır.</p><br> <p>⚠️&nbsp;Ayarlanan restoranın çalışma modu değil, siparişin teslim edilebileceği saattir.</p> <p>Örneğin, restoran 22:00'a kadar açıksa ve teslimat 1 saat sürüyorsa, teslimatın bitiş tarihini 23:00 olarak belirtmeniz gerekir. Esasında, kısıtlamalarda siparişi alma zamanını siz belirlersiniz.</p><p>Benzer şekilde, restoran saat 10: 00'da ve aynı saatte yola çıkarsa, teslimatın başında saat 11:00'i belirtmeniz gerekir.</p>"
      help_delivery_process: "<p>Smartomato'nun ideolojisinde, müşteriden alınan siparişi yerine getirme süreci birkaç aşamadan oluşur:</p> <ol><li>Sipariş onayı ve mutabakata varma</li> <li>Siparişi mutfağa gönderme</li> <li>Sipariş hazırlama ve paketleme</li> <li>Kurye ile sipariş teslim alınması</li> <li>Siparişin götürülmesi</li> <li>Müşteriye sipariş teslimi</li></ol> <p>Sistemimizin teslimatın tüm ara aşamalarını hesaplaması ve sapmaları izlemesi için hazırlık süresi, teslimat ve toplam teslimat süresini ayarlayın. </p><p>Toplam teslimat süresi, hazırlık ve nakliye sürelerinin toplamından az olmamalıdır, ancak hazırlık başlamadan önce uzun bir onay süreci veya diğer organizasyon prosedürleri ima edilirse bu süreyi aşabilir. </p></div>"
      help_priority_text: '<p>Teslimat alanıyla kısmen veya tamamen eşleşen birkaç teslimat koşulu tanımlayabilirsiniz.</p> <p>Bu bölgeler bir restorana veya farklı restoranlara bağlanabilir.</p> <p>Uygun bölge seçimi aşağıdaki prensibe göre yapılacaktır.</p> <ol> <li>İlk olarak, Smartomato müşterinin adresini içeren bölgeleri belirleyecektir.</li> <li>Daha sonra çalışma saatlerine uygun bölgeler seçilecektir.</li> <li>Bundan sonra minimum sipariş büyüklüğüne uygun bölgeler seçilecektir.</li> </ol> <p>Birkaç bölge hala uyuyorsa, Smartomato en uygun olanı arayacaktır:</p> <ol> <li>Önceliği daha yüksek olan bölge önce seçilecektir (daha yüksek sayı, daha yüksek öncelik)</li> <li>Aynı önceliğe sahip birkaç tane varsa, en düşük teslimat fiyatı / en düşük minimum sipariş / en düşük teslimat süresine sahip bölge bulunur.</li> <li>Bunlardan birkaçı varsa, mevcut yükü dikkate alarak dinamik dağıtım geçerli olacaktır:</li> </ol> <p>Dinamik dağıtım ile, o anda daha az aktif siparişi olan restoranla ilişkili bölge seçilecek, böylece birden fazla restoran aynı adrese hizmet veriyorsa, eşit olarak yüklenecektir. </p>'
      help_advanced_courier_text: '<p>«Sipariş başına kargo ücreti» ni tanımlarsanız, sipariş raporlarında, kurye ile gruplama yaparken, kurye tarafından teslim edilen siparişlerin miktarını görebilirsiniz.</p> <p>⚠️ Lütfen tüm siparişlerin, iptal edilenlerin bile kayıt altına alınıdığını unutmayın, çünkü Şirketinizdeki ödeme politikasını bilmiyoruz. Rapordaki verileri düzeltmek için siparişleri duruma göre filtreleyebilirsiniz.</p>'
      help_rush_mode_text: '<p>Bu mod, restoranlardaki yöneticilerin çok fazla siparişleri olduğunda veya başka zorunlu bir sebep olduğunda daha uzun veya daha pahalı teslimata geçmelerine olanak tanır.</p> <p>Bazı alanları boş bırakabilirsiniz, ardından «yüksek talep» durumunda ilgili parametre değişmeyecektir.</p>'
    advanced_settings:
      title: 'Gelişmiş ayarlar'
      advanced_courier:
        title: 'Kurye ile ödeme'
      rush_settings:
        title: '«yüksek talep» seçenekleri için parametreler'
    timetable_title: 'Sipariş kabul zamanı'
    add_takeaway_or_delivery: 'Bölge ya da kendin gel al noktası ekle'
    is_takeaway: 'Kendin gel al seçenekleri'
    is_delivery: 'Teslimat seçenekleri'
    is_dine_in: 'Dine-in options' #TODO translate from English

  settings:
    analytics:
      title: 'Meta etiketler'
      sub_title: 'Bu etiketlerden gelen veriler, sayfa için bir duyuru oluşturmak amacıyla arama motorları ve sosyal ağlar tarafından kullanılır'
      meta_title_caption: 'Ayrıca {title sayfa olarak da kullanılacaktır'
      buttons:
        load_meta_image: 'Meta Image yükle'
        save: 'Kaydet'
        cancel: 'İptal'
      placeholders:
        services:
          identificator: 'Tanımlayıcı'
      labels:
        meta_title: 'Meta Title'
        meta_description: 'Meta Description'
        meta_image: 'Meta image'
      services:
        title: 'Web analitiği hizmetleri'
        subtitle: 'Web analitiği hizmetlerini Smartomato mağazasına bağlama imkanı'
        feature_text: 'Smartomato, istatistik toplama sistemlerinde müşterilerinizin aktivitelerini kaydedebilir Sadece katılımları değil, müşterilerinizi daha iyi anlamanızı sağlayacak hedefleri de kaydediyoruz. Smartomato, reklam kampanyalarının etkinliğini değerlendirebilmeniz için Google Analytics Gelişmiş E-ticaret ile de entegre edilmiştir.'
        labels:
          ga: 'Google Analytics'
          metrika: 'Yandex.Metrika'
          gtm: 'Google Tag Manager'
          fb_pixel: 'Facebook Pixel'
          vk_pixel: 'ВКонтакте Pixel'
          mail_pixel: 'Mail.Ru Counter ID'
          data_layer: "DataLayer'da e-ticaret izlemeyi etkinleştirin"
        data_layer_caption: "Widget, konukların eylemleri hakkında DataLayer'a bilgi gönderecektir."
        data_layer_more: 'DataLayer hakkında daha fazla bilgi'
        examples:
          ga: 'Örneğin: UA-61543473-1'
          metrika: 'Örneğin: 21277873'
          gtm: 'Örneğin: GTM-11XX1XX'
          fb_pixel: 'Örneğin: 111111111111 (12 veya daha fazla basamaklı sayısal kod)'
          vk_pixel: 'Örneğin: VK-RTRG-111111-aA1A1'
          mail_pixel: 'Örneğin: 123456'
        events:
          open:
            modal:
              order: 'Sipariş penceresi açıldı'
              receipt: 'Geçmiş sipariş açıldı'
              invite: 'İletişim davet kutusu açıldı'
            configurator: 'Büyük/küçük yapılandırıcı açıldı'
            quick_configurator: 've'
          copy_invite: 'Davet bağlantısı kopyalandı'
          dish_click: 'Yemeğe tıklandı'
          dish_add: 'Sepete yemek eklendi'
          show_delivery_zones: 'Teslimat bölgeleri haritası açıldı'
          address_autodetect: 'Otomatik algılama adresine tıklandı'
          click_pay: 'Öde düğmesine tıklandı'
          rder_paid: 'Sipariş ödendi'
          click_checkout:
            event: 'Sipariş ver düğmesine tıklandı '
            description:
              no_valid: 'Sipariş oluşturuldu (müşteri formu yanlış doldurduysa bu etkinlikler daha az olabilir)'
              and: 've'
    business_role:
      list_business_role: 'İş rollerinin listesi'
      add_new: 'Ekle'
      delete: 'İş rolünü kaldıralım mı?'
      cancel: 'Değişiklikleri iptal mi edelim?'
      title:
        is_exist: 'İşletme rolünü düzenle'
        is_new: 'Yeni iş rolü ekle'
      subtitile: 'Smartomat sisteminin parçalarına erişim'
      labels:
        name: 'Rol adı'
        permitted_statuses: 'İzin verilen sipariş durumları'
        privileges: 'Haklar'
        subject: 'Site'
        reports_access: 'Raporlara erişim'
      subject:
        table: 'Tablolar'
        courier: 'Kuryeler'
        organizasyon: 'Organizasyon'
        draft_dish: 'Yemekler'
        draft_category: 'Kategoriler'
        modifier_group: 'Değiştirici Grupları'
        modifier: 'Değiştiriciler'
        modifier_scheme: 'Bir tabaktaki değiştiricilerin şeması'
        modifier_scheme_item: 'Bir değiştirici şemasındaki gruplar'
        delivery_zone: 'Teslimat bölgeleri'
        order: 'Siparişler'
        client: 'Misafirler'
        client_tag: 'Guests etiketleri'
        staff_member: 'Çalışanlar'
        service: 'Ücret planları'
        service_subscription: 'Abonelik'
        invoice: 'Faturalar'
        invoice_item: 'Fatura ayrıntıları'
        billing_info: 'billing'
        bank_details: 'Banka bilgileri'
        tema: 'Tema Şablonları'
        skin: 'Tema'
        basket_item: 'Sipariş içeriği'
        buddy: 'Sipariş alıcılar'
        promo: 'Promosyonlar'
        advert: 'Bülten'
        banner: 'Afişler'
        loyalty_program: 'Sadakat programları'
        business_role: 'İş rolleri'
        cooking_line: 'Yemek pişirme odaları'
        payment: 'Ödemeler'
        dish: 'Web sitesi/uygulama yemekleri (salt okunur)'
        category: 'Web sitesi/Uygulama kategorileri (salt okunur)'
        api_user: 'kişisel hesap'
        restaurant: 'Restoranlar'
      actions:
        read: 'Görüntüle'
        create: 'Oluştur'
        update: 'Güncelle'
        destroy: 'Sil'
        qr: 'QR Kodu Oluştur'
        publish: 'Yayınla'
        stats: 'İstatistikler'
        upload_logo: 'Bir logo yükleniyor'
        remove_logo: 'Logoyu kaldır'
        upload_favicon: 'Favicon yükle'
        upload_meta_image: 'SEO görselleri'
        import_menu: 'Menüyü içe aktar (API)'
        support_issue: 'Destek mektupları'
        check_host: 'Etki alanını değiştir'
        reorder: 'Sıralama'
        upload_photo: 'Bir fotoğraf yükleniyor'
        upload_avatar: 'Avatar yükle'
        update_priorities: 'Sipariş önceliğini güncelleme'
        delay_bonus: 'Gecikme için bonus'
        status: 'Durum'
        receipt: 'sevk irsaliyesi'
        geocode: 'Coğrafi kodlama'
        reverse_geocode: 'Ters coğrafi kodlama'
        assign_zone: 'Bölge tanımla'
        confirm: 'Onay'
        set_client_sign: 'İstemci İmzası'
        place: 'Sipariş ver'
        dispose: 'Yazmak'
        select_bonus_dish: 'Hediye seçin'
        validate: 'Doğrula'
        logs: 'Günlükler'
        cancel_outsource: 'Dış kaynağı iptal et'
        place_outsource: 'Dış kaynak yerleştirme'
        bonus_log: 'Bonus geçmişi'
        commit_bonus_amount: 'İkramiyeleri değiştir'
        switch: 'Abonelik Değişikliği'
        detailed: 'Hesap ayrıntıları'
        configure: 'özelleştir'
        delete_photo: 'Fotoğrafı sil'
        select: 'Konuyu değiştir'
        create_promo_codes: 'Promosyon kodları oluştur'
        issue_promo_code: 'Promosyon kodlarını yayınla'
        delete_unused_promo_codes: 'Promosyon kodlarını sil'
        promo_codes_usage: 'Promosyon kodu istatistikleri'
        clients_count: 'Misafir sayısı'
        execute: 'Bülteni başlat'
        cancel: 'Bülteni İptal Et'
        statistics: 'Bülten istatistikleri'
        stat: 'Hesap günlüğü'
        availability: 'Kullanılabilirlik'
        checklist: 'Configuración inicial'
      placeholders:
        name: 'Rol adı'
        permitted_statuses: 'İzin verilen sipariş durumları'
      staff_members_count: 'Bu role sahip personel üyeleri: {{staffMembersCount}}'
    staff:
      list_staff: 'Çalışan listesi'
      add_new: 'Ekle'
      title:
        is_exist: 'Çalışanları düzenle'
        is_new: 'Yeni çalışan ekle'
      subtitile: "Çalışanların, Smartomato'nun sistem, kuruluş ve diğer hizmetlerine erişimi"
      labels:
        staff_disabled: 'Engellenen/İşten çıkarılan'
        staff_role: 'Çalışanın görevi'
        avatar: 'Avatar'
        name: 'Ad'
        phone: 'Telefon'
        login: 'Email (login)'
        password: 'Şifre'
        repeat_password: 'Onay'
        notifications: 'Bildirimler'
        connect_sip: 'SIP etkinleştir'
        sip_login: 'SIP adresi'
        sip_password: 'SIP şifresi'
        restaurant: 'Restoranlar'
        cooking_line: 'Üretim atölyesi'
      placeholders:
        name: 'Ad'
        phone: 'Telefon numarası girin'
        login: 'Email giriniz'
        password: 'Şifre girin'
        repeat_password: 'Şifreyi tekrarlayın'
      staff_disabled:
        text: "Smartomato'ya erişimi engelle"
        caption: "Bu, hesabı kaydeder ancak Smartomato'ya erişimi yasaklar"
      sip_enabled:
        title: 'Telefon ayarları'
        text: 'Yeni aramaları bildir'
        caption: 'SIP hesap sipariş sistemine bağlansın mı?'
      staff_restaurants: 'Bu çalışan için hangi restoranlar mevcut?'
      staff_cooking_lines: 'Çalışan hangi amaç için çalışıyor?'
      business_role:
        label: 'İşletme Rolü'
        caption: '⚠️ Dikkat: Bir işletme rolü seçildiğinde, çalışana standart rollerle hiçbir şekilde ilişkili olmayan ayrı haklar verilecektir'
      staff_role:
        admin:
          title: 'İdareci'
          description: 'Organizasyon yönetimine tam erişim'
        manager:
          title: 'Yönetici'
          description: 'Restoranlarda yemeklere ulaşılabilirliği yönetme'
        manager_logist:
          title: 'Lojistik yöneticisi'
          description: 'Müşteri yönetimi, tam lojistik döngüsü ve yemeklerin erişilebilirliği'
        logist:
          title: 'Lojistik'
          description: 'Sipariş lojistiği'
        regional_admin:
          title: 'Bölgesel İdareci (franchising)'
          description: 'Belirtilen restoranlar ve bunlardaki fiyatlar değiştirebilir. Belirtilen restoranlarda çalışanlar oluşturun.'
      notifications:
        name: 'Ad'
      notification_url: 'API entegrasyonu için'
    sip:
      title: 'Telefon ayarları'
      explanation: '<p>Smartomato, IP telefonu ile entegre olabilir ve telefon operatörünün işini büyük ölçüde basitleştirir.</p> <p>Daha telefonu açmadan çağrı merkezini kimin aradığını öğrenebilirsiniz.. Müşterinin adı, mevcut sipariş, daha önce yapılan siparişlerin geçmişi ve ihtiyacınız olan diğer her şey.</p>'
      disabled:
        before_link: 'Tarife planınızın entegrasyon imkanı mevcut değil. Ancak'
        link: ' tarife planınızı değiştirebilirsiniz '
        after_link: 've telefon entegrasyonunu etkinleştirebilirsiniz.'
      enabled:
        before_link: 'Entegrasyon kurmak için bölümde çağrı alacak çalışanları seçmeniz gerekir.'
        link: 'Çalışanlar. '
        after_link: 'Her çalışan için düzenleme kartındaki «Telefon» bölümünde bir sip-login ve şifre belirtmeniz gerekir.'
      staff_with_sip:
        title: 'Çağrılar şu anda kabul edilecektir.'
        go_to_staff: 'çağrı alma yönetim sistemine git'
    organization:
      title: 'Kuruluş ayarları'
      subtitle: "Aşağıdaki formu doldurun ve lütfen kaydet'i tıklayın"
      caption:
        id: 'ID kimliği, entegrasyon için, özellikle de sitenize <a href="https://developer.smartomato.ru/widget">widget\'ı yerleştirme</a> Smartomato için gerekli olabilir'
      labels:
        id: "Kuruluş ID'si"
        logo: 'Logo'
        name: 'Kuruluş adı'
        phone: 'Telefon'
        about: 'Açıklama'
        hostname: 'Site adresi'
        advanced_head: 'Smartomato gelişmiş vitrin ayarları'
        advanced_settings:
          head:
            caption:
              description: 'Bu kod &lt;HEAD&gt; sayfa bölümünde yerleşir. Burada isteğe bağlı HTML, CSS veya JavaScript belirtebilirsiniz (&lt;STYLE&gt и &lt;SCRIPT&gt etiketlerini kullanın).'
              warning: 'Dikkat!'
              ask_support_description_before: 'Kod, yayınlanmadan sayfada görünüyor, dikkatli olun. Bunlara dikkat ediniz '
              ask_support: 'destek'
              ask_support_description_after: ', tüm bunların neden gerekli olduğunu tam olarak anlamadıysanız :) Size yardımcı olmaktan memnuniyet duyarız.'
          body:
            caption:
              description: 'Benzer, ancak sayfanın altında'
        advanced_body: 'Sayfa sonuna yerleştirilecek kod'
        timezone: 'Saat dilimi'
        is_published: 'Yayınlama'
        vk: 'Vkontakte'
      buttons:
        upload_logo: 'Logo yükle'
        change_host: 'Değiştir'
        upload_favicon: 'Favicon yükle'
      is_published:
        text: 'Restoran yayınla'
        description: 'Restoran verilen adreste mevcut mu?'
      placeholders:
        name: 'Ad'
        phone: 'Telefon numarası girin'
        about: 'Kuruluş açıklaması'
        advanced_head: 'Gelişmiş site ayarları (HEAD bölümü)'
        advanced_body: 'Gelişmiş site ayarları (BODY bölümü)'
      lang_settings_helper: 'Kuruluşun para birimini veya dil ayarlarını değiştirmeniz gerekirse, destek bölümünden bize yazın, size yardımcı olalım.'
    host:
      title: 'Domen adı değişikliği'
      subtitile: 'Smartomato vitrininin mevcut olacağı adres seçimi'
      explanation:
        text: 'Smartomato vitrini için <b>*.smartomato.ru</b> bölgesindeki adresi kullanabilir veya kendi alan adınızı bağlayabilirsiniz.. <b>restoran_adı.smartomato.ru</b> gibi bir adres için, boş bir adresi seçin, her şey otomatik olarak çalışacaktır!'
        before_link: 'Kendi adresinizi kullanmak biraz daha karmaşıktır, ancak size ipucu vereceğiz.'
        link: 'Destek bölümünden bize yazın'
        after_link: ', en kısa sürede size yardımcı olmak için gerekli çabayı göstereceğiz'
    integrations:
      title: "Smartomato'da Entegrasyon"
      feature_text: 'Smartomato birçok servisle etkileşim içinde çalışabilir, bize yazın ve her şeyi ayarlamanıza yardımcı olalım.'
      feature:
        pos:
          title: 'Restoran muhasebesi'
          poster:
            title: 'Poster'
            description: "Smartomato'dan onaylanan siparişlerin mutfağa gönderilmesi. Menüleri ve restoranları Poster'den Smartomato'ya aktarın."
          r_keeper:
            title: 'R-Keeper'
            description: "Smartomato'dan onaylanan siparişlerin mutfağa gönderilmesi."
          iiko:
            title: 'Iiko'
            description: "Smartomato'dan onaylanan siparişlerin mutfağa gönderilmesi."
        aquiring:
          title: 'Acquiring'
          yandex:
            title: 'Yandex.Kassa'
            description: 'Online ödeme kabulü.  Visa, Mastercard, Maestro, Мir, JCB, Diners Club, American Express banka kartları. Yandex.Money QIWI Cüzdan.'
          cloud_payments:
            title: 'Cloudpayments'
            description: 'Online ödeme kabulü. Visa, Mastercard, Maestro, Мir banka kartları.'
          sberbank:
            title: 'Sberbank'
            description: 'Online ödeme kabulü. Visa, Mastercard, Maestro, Мir banka kartları.'
          ibox:
            title: 'iBox'
            description: 'Akıllı telefon ve mobil terminal kullanarak nakit dışı ödeme kabulü. Visa, Mastercard, Maestro, Мir banka kartları.'
          pay_keeper:
            title: 'PayKeeper'
            description: 'Bankalardan acquiring işlemi: VTB, Sberbank, Promsvyazbank, Bank Otkritie, Moscow Credit Bank, Russian Standard Bank, TransKapitalBank, Gazprombank, URALSIB BANK, Bank St. Petersburg, UBRD, POST BANK, QIWI Bank'
        loyalty:
          title: 'Sadakat sistemi'
          sber_food:
            title: 'Sberfood'
            description: 'SberFood kullanan restoranlar, Smartomato arayüzündeki bonus kullanımına ilişkin bilgileri takip ediyor ve restoran misafirleri, teslimat siparişi verme esnasında ikramiye biriktiriyor ve bunları harcıyorlar.'
          premium_bonus:
            title: 'Premium Bonus'
            description: 'Restoranı çevrimdışı olarak ziyaret ederken ve teslimat siparişi verirken Misafire ait bonus hesabı mevcuttur. Müşteri hakkındaki bonus biriktşrme ve alınma verilerinin iki yönlü senkronizasyonu'
        analytics:
          title: 'Uçtan uca analitik'
          calltouch:
            title: 'Calltouch'
            description: "Sipariş bilgilerinin telefonla otomatik olarak Calltouch'a işlem şeklinde aktarılması ve reklam kaynaklarının atanması."
        delivery_outsource:
          title: 'Harici kaynak kullanımıyla teslimat'
          yandex_go:
            title: 'Yandex.Delivery'
            description: "Smartomato'dan otomatik teslimat talebi oluşturma ve Yandex.Delivery'e aktarma, sipariş durumlarının senkronizasyonu, sübvansiyon ayarları ve detaylı raporlar."
          dostavista:
            title: 'Dostavista'
            description: 'Tam otomasyon: Teslimat maliyetinin ve süresinin hesaplanması, teslimat talebinin aktarılması, sipariş durumlarının senkronize olarak değişimi, raporlama.'
        messaging:
          title: 'SMS ve mesajlaşma programı'
          main_sms:
            title: 'MainSMS'
            description: 'Seçilen gönderici adına sahip müşterilere SMS.'
          smsc:
            title: 'SMS mekezi'
            description: 'Seçilen gönderici adına sahip müşterilere SMS.'
          megafon:
            title: 'Megafon'
            description: 'Seçilen gönderici adına sahip müşterilere SMS.'
          infobip:
            title: 'Infobip'
            description: 'Seçilen gönderici adına sahip müşterilere SMS. Habercilere mesaj gönderme geliştirme aşamasındadır'
        aggregators:
          title: 'Toplayıcılar'
          yandex_eda:
            title: 'Yandex.Eda'
            description: 'Restoran menüsünün servise yüklenmesi. Yandex.Eda üzerinden alınan siparişlerin işlenmesi (import, bildirimler, iptal, durum güncelleme).'
          delivery_club:
            title: 'Delivery Club'
            description: 'Restoran menüsünün servise yüklenmesi. Delivery Club üzerinden alınan siparişlerin işlenmesi (içe aktarma, bildirimler, iptal, durum güncelleme).'
          broniboy:
            title: 'Broniboy'
            description: 'Restoran menüsünün servise yüklenmesi. Alınan siparişlerin işlenmesi (içe aktarma, bildirimler, iptal, durum güncelleme).'
          obed_ru:
            title: 'Obed.ru'
            description: 'Obed.ru aracılığıyla içe alınan siparişler'
          zakazaka:
            title: 'ZakaZaka'
            description: 'Restoran menüsünün servise yüklenmesi. ZakaZaka üzerinden alınan siparişlerin işlenmesi (import, bildirimler, iptal, durum güncelleme).'
          chibbis:
            title: 'Chibbis'
            description: 'Restoran menüsünün servise yüklenmesi. Chibbis üzerinden alınan siparişlerin işlenmesi (import, bildirimler, iptal, durum güncelleme).'
          glovo:
            title: 'Glovo'
            description: 'Restoran menüsünün servise yüklenmesi. Glovo üzerinden alınan siparişlerin işlenmesi (import, bildirimler, iptal, durum güncelleme).'
          vk:
            title: 'Vk'
            description: 'Restoran menüsünün servise yüklenmesi. Vk üzerinden alınan siparişlerin işlenmesi (import, bildirimler, iptal, durum güncelleme).'
          sbermarket:
            title: 'Sbermarket'
            description: 'Restoran menüsünün servise yüklenmesi. Sbermarket üzerinden alınan siparişlerin işlenmesi (import, bildirimler, iptal, durum güncelleme).'
      buttons:
        connect: 'Bağlan'
    payments:
      title: 'Müşterilerin siparişler için ödeme yöntemleri'
      subtitile: 'Sipariş verme esnasında ödeme yöntemlerinin kullanılabilirliğini yönetme'
      feature:
        description: 'Müşterinin sipariş verirken seçebileceği ödeme yöntemlerini belirtin. Lütfen bazı ödeme yöntemlerinin ek ayarlar gerektirdiğini unutmayın.'
        cash:
          title: 'Teslimat sırasında nakit ödeme'
          description: 'Ödeme, siparişin alınmasından sonra kuryeye yapılır. Bu durumda, sipariş formunda, kuryenin müşteriyle belirli bir miktar para üstü alış verişi gerekliliği ile ilgili bir soru olacaktır. Bu hizmet herhangi bir ek ayar gerektirmez.'
        card_online:
          title: 'Online kartla'
          caption:
            before_support: 'Sipariş verdikten sonra müşteriden siparişin ödemesini yapmak için kart bilgilerini girmesi istenir. Bu ödeme yönteminin çalışması için İnternet edinme ile entegrasyon gereklidir, bunu yapmak zor değildir - '
            support: 'bize yazın'
            after_support: ' ve biz her şeyi yapalım .'
        courier_card:
          title: 'Teslimat sırasında kartla ödeme'
          description: 'Bu ödeme yöntemi, kuryelerinizin mobil terminalleri varsa mümkündür. <a href="https://play.google.com/store/apps/details?id=ru.smartomato.order_machine" target="_blank"> Smartomato</a> kurye uygulamasında <a href="http://iboxmpos.com/" target="_blank">iboxPro</a>, akıllı telefonunuzu kullanarak kart kabul etmenizi sağlayan entegrasyon hizmeti mevcuttur.'
    profile:
      title: 'Profil ayarları'
      subtitle: 'Burada profilinizi düzenleyebilirsiniz'
      labels:
        photo: 'Avatar'
        name: 'Ad'
        phone: 'Telefon'
        login: 'Email (login)'
        password: 'Şifre'
        password_repeat: 'Şifreyi tekrarla'
      placeholders:
        name: 'Ad'
        phone: 'Telefon numarası girin'
        login: 'Email giriniz'
        password: 'Şifre girin'
        password_repeat: 'Şifreyi tekrarlayın'
    developer_settings:
      title: 'Ek özellikler'
      subtitle: 'İleri seviye kullanıcılar için ayarlar ve özellikler bölümü'
      feature:
        import_menu:
          title: 'Menü içe aktarma'
          description: '<p>Kuruluş menüsünü JSON dosyasından toplu olarak yükleme. Kullanmadan önce <a href="http://developer.smartomato.ru/api">Smartomato geliştirici belgelerindeki dosya biçimi açıklamasını okuyun.</a></p> <p>Dikkat! Eski menü, tamamen içe aktarılanla değiştirilecek ve bu istatistik bilgilerinin kaybına neden olabilir. </p>'
        import_clients:
          title: 'Müşteri aktarma'
          description: '<p>Müşteri bilgilerini JSON dosyasından toplu olarak yükleme. Kullanmadan önce <a href="http://developer.smartomato.ru/api">Smartomato geliştirici belgelerindeki dosya biçimi açıklamasını okuyun.</a></p>'
          label: 'Önceden oluşturulmuş müşterileri sil'
        board2:
          title: 'Board2'
          description: '<p>Board2, Smartomato\'nun entegrasyonlarını ve belirli özelliklerini yapılandırmak için ayrı bir arayüzdür.</p>
                        <p><a href="//smartomato.ru/board2" target="_blank">Yeni sekmede aç</a></p>'
    interface:
      title: 'Arayüz ayarları'
      subtitle: 'Belirli bir tarayıcı için çalışma seçenekleri kaydedilir'
      feature:
        language:
          label: 'Bu arayüzün dili'
          caption: 'Bu ayar SADECE geçerli tarayıcıdaki kullanıcı arayüzünü değiştirir, hiçbir organizasyon ayarı değiştirilmez'
        low_perfomance:
          description: 'Çok fazla siparişiniz varsa, bilgisayar başa çıkamaz ve arayüz yanıt vermez hale gelirse etkinleştirin'
          disable: 'Varsayılan mod, sınırsız'
          enable: 'Artık arayüz daha az bilgi gösteriyor ve daha az sıklıkta güncelleme yapmaya çalışıyor'
        hide_map:
          description: 'Siparişler ile yer iminde haritayı gösterme'
          enable: 'Harita gizli, bu bilgisayardaki yükü de azaltır'
          disable: 'Harita görüntülenecek'
        map_mouse_wheel:
          description: 'Mouse kullanarak haritanın ölçeğini kontrol edin'
          enable: 'Mouse tekerleği ölçeği değiştirecektir'
          disable: 'Mouse tekerleği kayacak'
        check_interval:
          description: 'Siparişlerdeki kontrol noktalarını güncelleme sıklığı'
          enable: 'Yenileme aralığı {{interval}} dk. olarak ayarlandı.'
        notification_duration:
          description: 'Tost bildiriminin ne kadar süreyle gösterileceği'
          enable: 'Bildirimler {{interval}} saniye sonra gizlenecektir.'
        hide_order_notifications:
          description: 'Yeni siparişler ve durum değişiklikleri hakkındaki bildirimleri gizleyin'
          enable: 'Bildirimler gizlendi'
          disable: 'Bildirimler görüntüleniyor'
        hide_pickup_orders_at_now:
          description: 'Kendin gel al siparişlerini "Şimdi" sipariş listesinde gizle'
          enable: 'Kendin gel al siparişleri gizlendi'
          disable: 'Tüm siparişle görüntüleniyor'
        sound_notifications:
          description: 'Yeni bir sipariş geldiğinde sesli uyarıları çal'
          enable: '<br>Sesli uyarılar etkinleştirildi!'
        sound_notifications_verbose:
          description: 'Herhangi bir etkinlikte sesli uyarı çal (önerilmez)'
          enable: '<br>🎉🥁🥳🎊!'
        sound_notifications_repeat:
          description: 'Yeni bir sipariş geldiğinde sesli bildirimleri tekrarlayın'
          enable: '<br>Sesli bildirimlerin tekrarı etkinleştirildi!'
        repeat_interval:
          description: 'Tekrarlanan ses bildirimlerinin sıklığı'
          enable: 'Tekrar aralığı {{interval}} sn.'
        integrations_settings:
          description: 'Kontrol panelinden entegrasyon ayarlarını açın'
          enable: '<br>Entegrasyon ayarları artık ayrı bir pencerede değil!'
        hide_later_orders_on_map:
          description: 'Haritada "Sonra" siparişlerini gizle'
          enable: '<br>Haritada yalnızca "Şimdi" siparişleri görünecek'
        hide_unauthorized_couriers:
          description: 'Haritada yetkisiz kuryeleri gizle'
          enable: '<br>Haritada sadece çalışan kuryeler gösterilecek'
        show_button_for_optional_modifiers:
          description: 'Sipariş kartındaki isteğe bağlı değiştiriciler için ayrı düğme'
          enable: '<br>Zorunlu değiştiriciler yemeğe tıklandığında mevcut olacak, isteğe bağlı değiştiriciler ise yemeğin yanındaki düğmeye tıklandığında mevcut olacak'
        show_dish_photo_in_order_card:
          description: 'Sipariş kartında yemeklerin fotoğraflarını göster'
          enable: '<br>Yemeklerin fotoğrafları sipariş kartında gösterilecektir'
  sm_chosen:
    nothing_found: 'hiçbir şey bulunamadı'
    buttons:
      add_button: 'Ekle'
    placeholders:
      search: 'Ara'
  date_range_report:
    from: 'от'
    to: 'kadar'
  day_editor:
    to: 'kadar'
    add: 'Ekle'
    time_hint: "Dönem eklemek için önceki dönemi ayarlamanız gerekir, 23:59'da bitmemesi gerekir."
    not_working: 'Çalışmıyoruz'
  sm_delivery_map:
    buttons:
      finish: 'Bitir'
      cancel: 'İptal'
  sm_button:
    back: 'Geri'
    save: 'Kaydet'
    cancel: 'İptal'
    delete: 'Sil'
    upload: 'Yükle'
    change: 'Değiştir'
  sm_notification_limiter:
    text: 'Daha fazla {{noticifationPending}} bildirim'
    hide_all: 'Tüm bildirimleri kapat'
  tariff:
    price_text: '{{tarrifPrice}} r/Ay'
    buttons:
      select_tariff: 'Seç'
    full_tariffs: '<a href="https://smartomato.ru/pricing" target="_blank">Smartomato web sitesinde tarifelerin tam versiyonları ve karşılaştırmaları</a>.'
  available:
    available: 'Mevcut'
    not_available: 'Durdurma listesinde'
    call: 'Müsaitliği telefonla kontrol edin'
  validation:
    phone: 'Telefon numarası yalnızca rakam ve + içermelidir'
    login: 'Yanlış E-posta'
    required_field: 'Zorunlu Alan'